//Paquetes NPM de GYF. 
import { LogHelper } from 'com-gyf-webcore-loghelper';
import { Engine1Proxy, RestApiProxy, RabbitListener, SagasProxy, ConciergeProxy } from 'com-gyf-webcore-servicehub';
import GlobalHelper from '../../../Common/Helpers/GlobalHelper';
import ContactoHelper from '../../../Common/Helpers/ContactoHelper';
import NovedadesManager from '../../../Common/Managers/NovedadesManager';
import EstadoManager from '../../../Common/Managers/EstadoManager';

//Seteo de apiUrl
RestApiProxy.SetApiUrl();

//ACTION TYPES

export const GET_SCREEN_DATA_CLIENTE = 'GET_SCREEN_DATA_CLIENTE';
export const GET_OPCIONES_MODIFICACION_CLIENTE = 'GET_OPCIONES_MODIFICACION_CLIENTE';
export const EDITANDO_CAMPO_CLIENTE = "EDITANDO_CAMPO_CLIENTE";
export const MOSTRAR_SPINNER = "MOSTRAR_SPINNER";
export const CANCEL_NOVEDAD_CLIENTE = "CANCEL_NOVEDAD_CLIENTE";
export const SAVE_NOVEDAD_CLIENTE = "SAVE_NOVEDAD_CLIENTE";
export const ACEPTA_ADMINISTRADORA_CLIENTE = "ACEPTA_ADMINISTRADORA_CLIENTE";
export const RECHAZA_ADMINISTRADORA_CLIENTE = "RECHAZA_ADMINISTRADORA_CLIENTE";
export const SELECCIONAR_VALOR_CAMPO_CLIENTE = "SELECCIONAR_VALOR_CAMPO_CLIENTE";
export const GET_LOG_MODIFICACIONES_CUENTA_CLIENTE = "GET_LOG_MODIFICACIONES_CUENTA_CLIENTE";
export const ACTUALIZAR_ESTADO_NOVEDAD_CLIENTE = "ACTUALIZAR_ESTADO_NOVEDAD_CLIENTE";
export const DENIEGA_NOVEDAD_CLIENTE = "DENIEGA_NOVEDAD_CLIENTE";
export const LIMPIAR_STORE_COMPONENTE_CLIENTE = "LIMPIAR_STORE_COMPONENTE_CLIENTE";
export const GET_LOG_MODIFICACIONES_CLIENTE = "GET_LOG_MODIFICACIONES_CLIENTE";
export const ABRIR_MODAL_LOCALIZACION = "ABRIR_MODAL_LOCALIZACION";
export const EDITAR_CAMPO_LOCALIZACION = "EDITAR_CAMPO_LOCALIZACION";
export const LIMPIAR_EDICIONES = "LIMPIAR_EDICIONES";
export const SELECT_CHECK = "SELECT_CHECK";
export const SELECT_CHECK_DOMICILIO = "SELECT_CHECK_DOMICILIO";
export const ERROR_VALIDACION_LOCALIZACION = "ERROR_VALIDACION_LOCALIZACION";
export const MODAL_CONFIRMADOR = "MODAL_CONFIRMADOR";
export const ABRIR_MODAL_LOCALIZACION_MODIFICACION = "ABRIR_MODAL_LOCALIZACION_MODIFICACION";
export const ABRIR_MODAL_DOMICILIO_MODIFICACION = "ABRIR_MODAL_DOMICILIO_MODIFICACION";
export const ACTUALIZAR_LOCALIZACION_CLIENTE = "ACTUALIZAR_LOCALIZACION_CLIENTE";
export const ABRIR_MODAL_LOCALIZACION_ELIMINAR = "ABRIR_MODAL_LOCALIZACION_ELIMINAR";
export const MODAL_ADVERTENCIA_DIRECCION_EXISTENTE = "MODAL_ADVERTENCIA_DIRECCION_EXISTENTE";
export const INTENTOS_AGOTADOS_GUARDADO_GLOBAL = "INTENTOS_AGOTADOS_GUARDADO_GLOBAL";
export const LOADING_CLIENTE = "LOADING_CLIENTE";
export const ACEPTAR_MODAL_INFO = "ACEPTAR_MODAL_INFO";
export const MOSTRAR_ERROR_VALIDACION = "MOSTRAR_ERROR_VALIDACION";
export const CAMPO_EN_PROCESO = "CAMPO_EN_PROCESO";
export const SELECT_COMBO = "SELECT_COMBO";
export const GET_SCREEN_DATA_DOMICILIO = "GET_SCREEN_DATA_DOMICILIO";
export const MODAL_ADVERTENCIA_DOMICILIO_EXISTENTE = "MODAL_ADVERTENCIA_DOMICILIO_EXISTENTE";
export const ABRIR_MODAL_ADVERTENCIA_DOMICILIO_LEGAL = "ABRIR_MODAL_ADVERTENCIA_DOMICILIO_LEGAL";


let _dispatch, _ultimaNovedad, _cambioEnviado = false;
let telPrePago, telFijo;

//ACTIONS

/** 
 * Action que obtiene el estado inicial con todos los datos del cliente a partir de los obtenidos en la búsqueda de clientes.
 * @param {any} state
 * @param {any} currentScope
 */
export function getScreenData(cliente) {
    LogHelper.In(getScreenData.name);
    return (dispatch, getState) => {
        var _dispatch = dispatch;
        
        let state = getState();

        let param = {
            'CLIENTE_ID':parseInt(cliente.Id)
        }

        let localValue = {
            'ADMINISTRADORA_ID': 3
        };
        let parameter = {
            'NRO_CLI': cliente.CliNum
        }

        let paramDom = {
            'DOMICILIO_ID': null,
            'CLIENTE_ID':parseInt(cliente.Id)
        }

        
        LogHelper.Out(getScreenData.name, param, 'GET_CLIENTE_BY_ID', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(param, 'GET_CLIENTE_BY_ID', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');

        Engine1Proxy.AddDataSourcesRequests(param, 'GET_DOMICILIOS_BY_ID_CLIENTE', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'Product', true);
        LogHelper.Out(getScreenData.name, param, 'GET_DOMICILIOS_BY_ID_CLIENTE', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Socios');
                
        Engine1Proxy.AddDataSourcesRequests(param, 'GET_CONTACTO_BY_ID_CLIENTE', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'Product', true);
        LogHelper.Out(getScreenData.name, param, 'GET_CONTACTO_BY_ID_CLIENTE', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Socios');

        Engine1Proxy.AddDataSourcesRequests(param, 'GET_OPCIONES_MODIFICACION_CLIENTE', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'Product', true);
        LogHelper.Out(getScreenData.name, param, 'GET_OPCIONES_MODIFICACION_CLIENTE', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Socios');

        Engine1Proxy.AddDataSourcesRequests(param, 'GET_NOVEDADES_BY_CLIENTE_ID', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'Product', true);
        LogHelper.Out(getScreenData.name, param, 'GET_NOVEDADES_BY_CLIENTE_ID', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Socios');

        LogHelper.Out(getScreenData.name, param, 'CONSULTA_SOLICITUD_CUENTA_CUENTAS', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true);
        Engine1Proxy.AddDataSourcesRequests(param, 'CONSULTA_SOLICITUD_CUENTA_CUENTAS', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true);

        Engine1Proxy.AddDataSourcesRequests(localValue, 'GET_PARAMETRO_GENERAL', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');      

        LogHelper.Out(getScreenData.name, param, 'UP_GET_DATOS_AltaDomicilioPostal', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true);
        Engine1Proxy.AddDataSourcesRequests(param, 'UP_GET_DATOS_AltaDomicilioPostal', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true);

        LogHelper.Out(getScreenData.name, paramDom, 'GET_DOMICILIOS_BY_CLIENTE_ID', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true);
        Engine1Proxy.AddDataSourcesRequests(paramDom, 'GET_DOMICILIOS_BY_CLIENTE_ID', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true);


        Engine1Proxy.Execute((data)=>_callBackGetScreenData(data,cliente,dispatch), null, null, "CONSULTASOCIOS");
    }
}



function _callBackGetScreenData(data,cliente,dispatch){

    let tiposCuentaDisponibles = "";

    let ClienteActualizado = JSON.parse(data.GET_CLIENTE_BY_ID).Recordset0.Rows[0];

    let contacto = JSON.parse(data.GET_CONTACTO_BY_ID_CLIENTE).Recordset0.Rows;

    let contactosSinCuenta = JSON.parse(data.GET_CONTACTO_BY_ID_CLIENTE).Recordset1.Rows; //emails con el campo CuentaTarjetaId en NULL

    contacto = contacto.concat(contactosSinCuenta); 
    
    let contactosTotal = JSON.parse(JSON.stringify(contacto));

    let arregloLocalizacionContacto = ContactoHelper.ComunicacionHelper(contacto);

    let domAux = JSON.parse(data.GET_DOMICILIOS_BY_CLIENTE_ID);

    //ACTUALMENTE SE GUARDA EL CODIGO POSTAL Y NO EL ID DE CODIGO POSTAL EN LA TABLA DOMICILIO, LO QUE PUEDE GENERAR DUPLICACION DE REGISTROS PORQUE DOS REGISTROS DE ATLAS_CODIGO_POSTAL PUEDEN TENER EL MISMO

    let infoDomiciliosCuenta = domAux.Recordset1.Rows;
    
    let domiciliosTotal = ContactoHelper.DomicilioHelper(domAux.Recordset0.Rows, domAux.Recordset1.Rows);
    domiciliosTotal.map(d=>d.MedioNombre= "POSTAL");
    
    let parametroGeneral = JSON.parse(data.GET_PARAMETRO_GENERAL).Recordset0.Rows;

    let novedades = JSON.parse(data.GET_NOVEDADES_BY_CLIENTE_ID).Recordset0.Rows;

    let cuentas = JSON.parse(data.CONSULTA_SOLICITUD_CUENTA_CUENTAS).Recordset0.Rows;

    let domiciliosCliente = JSON.parse(data.CONSULTA_SOLICITUD_CUENTA_CUENTAS).Recordset0.Rows;
    
    let existeCuentaTP = cuentas.some(cuenta=>cuenta.tipoProducto == "TP");
    let existeCuentaTC = cuentas.some(cuenta=>cuenta.tipoProducto == "TC");

    if(existeCuentaTC && existeCuentaTP) tiposCuentaDisponibles = "AMBAS"
    else if(existeCuentaTP) tiposCuentaDisponibles ="TP"
    else if(existeCuentaTC) tiposCuentaDisponibles = "TC"
    
    let cuentaPrepaga = null;
    let cuentaCredito = null;

    cuentas.map(c=>{
        if(c.tipoProducto == "TP") cuentaPrepaga = c;
        if(c.tipoProducto == "TC") cuentaCredito = c;
    })

    let opcionesModificacion={
        Nacionalidad  : JSON.parse(data.GET_OPCIONES_MODIFICACION_CLIENTE).Recordset0.Rows,
        EstadoCivil : JSON.parse(data.GET_OPCIONES_MODIFICACION_CLIENTE).Recordset1.Rows,
        CategoriaIva : JSON.parse(data.GET_OPCIONES_MODIFICACION_CLIENTE).Recordset2.Rows,
        CondicionOcupacion : JSON.parse(data.GET_OPCIONES_MODIFICACION_CLIENTE).Recordset3.Rows,
        TipoDocumento: JSON.parse(data.GET_OPCIONES_MODIFICACION_CLIENTE).Recordset4.Rows
    }

    ClienteActualizado.Contacto = contacto;
    ClienteActualizado.Domicilios = []//domiciliosTotal;
    ClienteActualizado.DomicilioComponentes = {};
    
    dispatch({ type: GET_SCREEN_DATA_CLIENTE, ClienteActualizado });
    dispatch({ type: GET_SCREEN_DATA_DOMICILIO, domicilios: domiciliosTotal, infoDomiciliosCuenta });
    dispatch({ type: GET_OPCIONES_MODIFICACION_CLIENTE, opcionesModificacion, parametroGeneral, novedades, cliente : ClienteActualizado,cuenta : cuentaPrepaga, tiposCuentaDisponibles, arregloLocalizacionContacto, contactosTotal,cuentaCredito });
}

export function aceptarModalInfo(){
    return (dispatch,getState)=>{
        dispatch({ type: ACEPTAR_MODAL_INFO });
    }
}

export function seleccionarCombo(valor, combo, ...params) {
    LogHelper.In(seleccionarCombo.name, valor, combo);

    return (dispatch, getState) => {
        dispatch({ type: SELECT_COMBO, valor, combo });
    }
}

export function selectCheckDomicilio(componente, value, params) {
    LogHelper.In(selectCheckDomicilio.name, componente, value, params);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: SELECT_CHECK_DOMICILIO, componente, value, params });
    }
}


export function getLogModificaciones(novedadCodigo,clienteId){
    LogHelper.In(getLogModificaciones.name, novedadCodigo,clienteId);
    
    return (dispatch, getState) => {
        if(novedadCodigo){
            
            _dispatch = dispatch

            let state = getState();


            let paramModificaciones={
                'NOVEDAD_CODIGO':novedadCodigo,
                'CLIENTE_ID': state.cliente.id
            };
            
            Engine1Proxy.AddDataSourcesRequests(paramModificaciones, 'GET_LOG_NOVEDAD_CLIENTE', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true, 'modificacionesCliente');
            Engine1Proxy.Execute((data) => _callBackGetLogModificaciones(data, novedadCodigo,state), null, null, "CONSULTASOCIOS"); 
        }else{
            
            dispatch({ type: GET_LOG_MODIFICACIONES_CLIENTE, modificaciones:null, campoCodigo:null });
        }
    }
}

function  _callBackGetLogModificaciones(data, novedadCodigo,state){
    let modificaciones = JSON.parse(data.modificacionesCliente).Recordset0.Rows;
    GlobalHelper.OrdenarArrayPorFecha(modificaciones,"FechaHoraModificacion");
    state = state.cliente;

    switch(novedadCodigo){
        case "SEXO_CLIE":{
            modificaciones.map(mod=>{
                if(mod.ValorAnterior == "M") mod.DescripcionAnterior = "Masculino"
                else if (mod.ValorAnterior == "F") mod.DescripcionAnterior = "Femenino"
    
                if(mod.ValorNovedad == "M") mod.DescripcionNovedad = "Masculino"
                else if (mod.ValorNovedad == "F") mod.DescripcionNovedad = "Femenino"
            })
            break;
        }

        case "NACION_CLIE":{
            modificaciones.map(mod=>{
                state.NACIONALIDAD_OPCIONES.map(nac=>{
                    if(mod.ValorAnterior && nac.Id == mod.ValorAnterior) mod.ValorAnterior = nac.Descripcion;
                    if(nac.Id == mod.ValorNovedad) mod.ValorNovedad = nac.Descripcion;
                })
            })
            break;
        }

        case "EDOCIVIL_CLIE":{
            modificaciones.map(mod=>{
                state.ESTADO_CIVIL_OPCIONES.map(nac=>{
                    if(mod.ValorAnterior && nac.Id == mod.ValorAnterior) mod.ValorAnterior = nac.Descripcion;
                    if(nac.Id == mod.ValorNovedad) mod.ValorNovedad = nac.Descripcion;
                })
            })
            break;
        }

        case "CONDIVA_CLIE":{
            modificaciones.map(mod=>{
                state.CATEGORIA_IVA_OPCIONES.map(nac=>{
                    if(mod.ValorAnterior && nac.Id == mod.ValorAnterior) mod.ValorAnterior = nac.Descripcion;
                    if(nac.Id == mod.ValorNovedad) mod.ValorNovedad = nac.Descripcion;
                })
            })
            break;
        }

        case "ACTIV_CLIE":{
            modificaciones.map(mod=>{
                state.OCUPACION_OPCIONES.map(nac=>{
                    if(mod.ValorAnterior && nac.Id == mod.ValorAnterior) mod.ValorAnterior = nac.Descripcion;
                    if(nac.Id == mod.ValorNovedad) mod.ValorNovedad = nac.Descripcion;
                })
            })
            break;
        }
    }


    
    _dispatch({ type: GET_LOG_MODIFICACIONES_CLIENTE, modificaciones, campoCodigo: novedadCodigo });
}

export function getLogModificacionesNombreCompleto(){
    return (dispatch,getState) =>{

        _dispatch = dispatch
        let state = getState();

        let paramModificacionesNombre={
            'NOVEDAD_CODIGO':"NOMBRE_CLIE",
            'CLIENTE_ID': state.cliente.id
        };
        let paramModificacionesApellido={
            'NOVEDAD_CODIGO':"APELLIDO_CLIE",
            'CLIENTE_ID': state.cliente.id
        };
        
        Engine1Proxy.AddDataSourcesRequests(paramModificacionesNombre, 'GET_LOG_NOVEDAD_CLIENTE', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true, 'modificacionesNombre');
        Engine1Proxy.AddDataSourcesRequests(paramModificacionesApellido, 'GET_LOG_NOVEDAD_CLIENTE', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true, 'modificacionesApellido');
        Engine1Proxy.Execute((data) => _callBackGetLogModificacionesNombreCompleto(data), null, null, "CONSULTASOCIOS"); 
    }

}

function  _callBackGetLogModificacionesNombreCompleto(data){
    
    let modificacionesNombre = JSON.parse(data.modificacionesNombre).Recordset0.Rows;
    let modificacionesApellido = JSON.parse(data.modificacionesApellido).Recordset0.Rows;
    let modTotal = modificacionesNombre.concat(modificacionesApellido);
    GlobalHelper.OrdenarArrayPorFecha(modTotal,"FechaHoraModificacion");
    
    _dispatch({ type: GET_LOG_MODIFICACIONES_CLIENTE, modificaciones: modTotal, campoCodigo: 'NOMBRE_COMPLETO' });
}

export function abrirModalLocalizacion(medio,accion){

    LogHelper.In(abrirModalLocalizacion.name, medio,accion);
    return (dispatch,getState) =>{
        _dispatch = dispatch;
        if(accion){
            switch(medio){
                case "TELEFONICO":{
                    let params={
                        'MEDIO':medio
                    }        
                    Engine1Proxy.AddDataSourcesRequests(params, 'GET_TIPOS_COMUNICACION_BY_MEDIO', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true, 'tiposComunicacion');
                    Engine1Proxy.AddDataSourcesRequests(params, 'GET_TIPOS_COMUNICACION_BY_MEDIO', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true, 'tiposComunicacion');
                    Engine1Proxy.Execute((data) => _callBackAbrirModalLocalizacion(data,medio), null, null, "CONSULTASOCIOS");                
                    break;
                }
                case "EMAIL":{
                    let state = getState();
                    let params={
                        'CLIENTE_ID':state.cliente.id
                    }        
                    Engine1Proxy.AddDataSourcesRequests(params, 'UP_GET_DATOS_AltaDireccionElectronica', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true, 'tiposComunicacion');
                    Engine1Proxy.Execute((data) => _callBackAbrirModalLocalizacion(data,medio), null, null, "CONSULTASOCIOS");                
                    break;
                }
                case "POSTAL":{
                    let state = getState();
                    if(!state.cliente.domicilioComponentes || !state.cliente.domicilioComponentes.paisRows){
                        //es una obtención costosa por la cantidad de datos, solo se solicita si no se pidió anteriormente
                        Engine1Proxy.AddDataSourcesRequests({}, 'UP_GET_DATOS_ModificacionDomicilioPostal', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true);
                        Engine1Proxy.Execute((data) => _callBackAbrirModalLocalizacion(data,medio), null, null, "CONSULTASOCIOS"); 
                    }else{
                        dispatch({ type: ABRIR_MODAL_LOCALIZACION, tiposComunicacion:null, medio, infoCuentas:null, emailCuentasActuales:null, opcionesModificacionDomicilio:null});
                    }
                    
                    break;
                }
            }
        }else{
            dispatch({ type: ABRIR_MODAL_LOCALIZACION, tiposComunicacion:null, medio:null });
            dispatch({ type: LIMPIAR_EDICIONES });
        }
    }
}

function _callBackAbrirModalLocalizacion(data,medio){

    let tiposComunicacion = data.tiposComunicacion ? JSON.parse(data.tiposComunicacion).Recordset0.Rows : null;
    let infoCuentas;
    let emailCuentasActuales;
    let opcionesModificacionDomicilioAux = data.UP_GET_DATOS_ModificacionDomicilioPostal ? JSON.parse(data.UP_GET_DATOS_ModificacionDomicilioPostal) : null;;
    let opcionesModificacionDomicilio;

    if(medio == "EMAIL"){
        infoCuentas = JSON.parse(data.tiposComunicacion).Recordset1.Rows;
        if(infoCuentas.some(c=>c.Email != null)){
            emailCuentasActuales = {};
            infoCuentas.map(cuenta=>{
                if(cuenta.Email){
                    emailCuentasActuales[cuenta.TipoCuenta] = {}
                    emailCuentasActuales[cuenta.TipoCuenta].Contacto =  cuenta.Email
                    emailCuentasActuales[cuenta.TipoCuenta].Id =  cuenta.EmailId                   
                } 
            })
        }
    }
    
    switch(medio){
        case "POSTAL":{
            opcionesModificacionDomicilio = {
                codigoPostalRows:  opcionesModificacionDomicilioAux.Recordset0.Rows,
                provinciaRows:  opcionesModificacionDomicilioAux.Recordset1.Rows,
                paisRows:  opcionesModificacionDomicilioAux.Recordset2.Rows
             }
            _dispatch({ type: ABRIR_MODAL_LOCALIZACION, tiposComunicacion, medio, infoCuentas, emailCuentasActuales, opcionesModificacionDomicilio});
            break;
        }
    }
    
    _dispatch({ type: ABRIR_MODAL_LOCALIZACION, tiposComunicacion, medio, infoCuentas, emailCuentasActuales});
}


export function editarCampoLocalizacion(campo,valor){
    LogHelper.In(editarCampoLocalizacion.name, campo,valor);
    let valida = true;
    
    //DEPENDIENDO DEL CAMPO REALIZA VALIDACIONES ANTES DE MODIFICAR EL VALOR O NO
    switch(campo){
        case "telefonoEnEdicion":{
            let regEx=/^[0-9]+$/
            valida = (regEx.test(valor) && valor.length < 11) || valor == "";
            break;
        }
        case "emailEnEdicion":{
            let regEx=/^[a-zA-Z0-9Ññ@+y#_.-]*$/
            valida = (regEx.test(valor) && valor.length < 41) || valor == "";
            break;
        }
        case "alturaEdicion":{
            let regEx=/^[0-9]+$/
            valida = (regEx.test(valor) && valor.length < 9) || valor == "";
            break;
        }
        case "calleEdicion":{
            let regEx=/^[a-zA-Z0-9ÑñáéíóúÁÉÍÓÚ'.\-\s]*$/
            valida = (regEx.test(valor) && valor.length < 36) || valor == "";
            break;
        }
        case "pisoEdicion":{
            let regEx=/^[a-zA-Z0-9ÑñáéíóúÁÉÍÓÚ'.\-\s]*$/
            valida = (regEx.test(valor) && valor.length < 3) || valor == "";
            break;
        }
        case "deptoEdicion":{
            let regEx=/^[a-zA-Z0-9ÑñáéíóúÁÉÍÓÚ'.\-\s]*$/
            valida = (regEx.test(valor) && valor.length < 9) || valor == "";
            break;
        }
        case "localidadEdicion":{
            let  regEx=/^[a-zA-Z0-9ÑñáéíóúÁÉÍÓÚ'.\-\s]*$/
            valida = (regEx.test(valor) && valor.length < 26) || valor == "";
            break;
        }
        case "comentariosDomicilioEdicion":{
            let  regEx=/^[a-zA-Z0-9ÑñáéíóúÁÉÍÓÚ'.\-\s]*$/
            valida = (regEx.test(valor) && valor.length <= 4000) || valor == "";
            break;
        }
        default:
            break
    }

        return (dispatch,getState) =>{
            dispatch({ type: EDITAR_CAMPO_LOCALIZACION, campoEnEdicion:campo, valor, valida });
        }

}

export function selectCheck(campo){
    LogHelper.In(selectCheck.name, campo);
    return (dispatch,getState) =>{

        let state = getState();
        state = state.cliente;

        let checkPrepaga = state.checkProductoPrepaga;
        let checkCredito = state.checkProductoCredito;

        if(campo == "checkProductoPrepaga"){
            if(!state.checkProductoPrepaga){
                checkPrepaga = true;
            }else{
                checkPrepaga = false;
            }
        }else if(campo == "checkProductoCredito"){
            if(!state.checkProductoCredito){
                checkCredito = true;
            }else{
                checkCredito = false;
            }
        }
        
        dispatch({ type: SELECT_CHECK, checkPrepaga,checkCredito });
    }
}

export function validarEdicionLocalizacion(campo, esModificacion){
    LogHelper.In(validarEdicionLocalizacion.name, campo, esModificacion);
    
    return (dispatch,getState) =>{ 
        //CUANDO SE DA CLICK A "ACEPTAR" PRIMERO SE VALIDAN LOS DATOS CORRESPONDIENTES, AGREGAR AL SWITCH DOMICILIO CUANDO CORRESPONDA
        let stateCuenta;
        let state = getState(); 
        let usuarioOperacion = state.sesion.executionContext.login;
        let mediosCliente = JSON.parse(JSON.stringify(state.tarjetas.Cliente.Contacto));
        let cuentaPrepaga = state.cliente.cuenta;
        let cuentaCredito = state.cliente.cuentaCredito;
        telPrePago = mediosCliente.filter(med=>med.CuentaTarjetaId != null && med.TipoComunicacionId != 2);
        telFijo = mediosCliente.filter(med=> med.TipoComunicacionId == 4);
        state = state.cliente;
        stateCuenta = state.cuenta;
        _dispatch = dispatch;


        //VALIDACIONES
        let  validaCamposEdicion = {
        } 
        switch(campo){
            case "TELEFONO":{

                validaCamposEdicion.tipoTelefono = _validarCampo(state.tipoTelefonoEnEdicion);
                //validaCamposEdicion.tipoProducto = _validarCampo(state.checkProductoCredito)  || _validarCampo(state.checkProductoPrepaga);
                validaCamposEdicion.telefono = _validarCampo(state.telefonoEnEdicion) && state.telefonoEnEdicion.length == 10;
                validaCamposEdicion.validarRegistros = true;

                mediosCliente.map(medio=>{
                    //VALIDACIÓN PARA SABER SI YA EXISTE EL MISMO NÚMERO DE TEL CON EL MISMO TIPO DE TEL REGISTRADO EN EL TIPO DE CUENTA AL QUE SE ESTÁ INTENTANDO AGREGAR
                    if(state.checkProductoCredito){
                        if(medio.Contacto == state.telefonoEnEdicion && medio.TipoComunicacionId == state.tipoTelefonoEnEdicion && medio.CuentaTarjetaId == cuentaCredito.CuentaTarjetaId){
                            validaCamposEdicion.validarRegistros = false;
                        }
                    }

                    if(state.checkProductoPrepaga){
                        if(medio.Contacto == state.telefonoEnEdicion && medio.TipoComunicacionId == state.tipoTelefonoEnEdicion && medio.CuentaTarjetaId == cuentaPrepaga.CuentaTarjetaId){
                            validaCamposEdicion.validarRegistros = false;
                        }
                    }
                })
                break;
            }

            case "EMAIL":{
                validaCamposEdicion.tipoDireccionElectronica = _validarCampo(state.tipoDireccionElectronica);
                validaCamposEdicion.email = _validarCampo(state.emailEnEdicion) && (/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/.test(state.emailEnEdicion) && state.emailEnEdicion.length < 41);
                //validaCamposEdicion.tipoProducto = _validarCampo(state.checkProductoCredito)  || _validarCampo(state.checkProductoPrepaga);
                let direcPrevia = _existeDireccionPrevia(state);
                validaCamposEdicion.mailRepetidoTP =  !direcPrevia.repetidoEnPrepaga
                validaCamposEdicion.mailRepetidoTC =  !direcPrevia.repetidoEnCredito

                if(!esModificacion){
                    validaCamposEdicion.mailRepetidoSinCuenta = !direcPrevia.repetidoSinCuenta
                }else{
                    let medioModif = state.medioLocalizacionModificacion[0];
                    if(!((!medioModif.TipoProducto && (state.checkProductoCredito || state.checkProductoPrepaga)) || (medioModif.TipoProducto && medioModif.TipoProducto.includes("Prepaga") && !state.checkProductoPrepaga) || (medioModif.TipoProducto && medioModif.TipoProducto.includes("de") && !state.checkProductoCredito))){
                        //SI LA FORMA COMUNICACION QUE SE ESTA MODIFICANDO NO ESTABA ASOCIADA A CUENTA Y AHORA SÍ, NO HACE FALTA QUE SE VALIDE SI SE REPITE EL NOMBRE
                        //LO MISMO SI SE ESTÁ DESAFECTANDO DE LA CUENTA
                        validaCamposEdicion.mailRepetidoSinCuenta = !direcPrevia.repetidoSinCuenta
                    }

                }
                break;
            }
            case "POSTAL":{
                debugger
                let domModif = state.domicilioModificacion;

                validaCamposEdicion.calle= _validarCampo(state.calleEdicion);
                validaCamposEdicion.altura= _validarCampo(state.alturaEdicion);
                validaCamposEdicion.localidad= _validarCampo(state.localidadEdicion);
                validaCamposEdicion.paisId= _validarCampo(state.paisId);
                validaCamposEdicion.provinciaId= _validarCampo(state.provinciaId);
                validaCamposEdicion.codigoPostalId= _validarCampo(state.codigoPostalId);
                validaCamposEdicion.domicilioLegalPrepaga = true;
                validaCamposEdicion.modificacionesDomicilio = true;
                validaCamposEdicion.checkDomicilioPrepago = false;
                

                if(state.domicilio.prepagoCheck){
                    validaCamposEdicion.checkDomicilioPrepago= state.tarjeta_prepaga.some(c=>c.Check);
                }

                if(state.domicilio.creditoCheck){
                    validaCamposEdicion.checkDomicilio= state.tarjeta_credito.some(c=>c.Check);
                }
                
                if(!esModificacion){
                    validaCamposEdicion.domicilioRepetido = (!state.domiciliosTotal.some(d=>d.Calle == state.calleEdicion && d.Numero == state.alturaEdicion && d.CodigoPostalId == state.domicilio.codigoPostalId));
                }else{
                    //se intenta desasociar el domicilio legal de la cuenta prepaga, lo que no es posible, solo puede ser reemplazado por otro, porque no puede haber cuenta sin domicilio legal
                    if(domModif.TipoProducto == "Tarjeta Prepaga" &&  domModif.EsDomicilioLegal && !state.tarjeta_prepaga.some(t=>t.Descripcion == "Legal" && t.Check)){
                        validaCamposEdicion.domicilioLegalPrepaga = false;
                    }
                    //se comprueba que se haya realizado alguna modificación
                    if(domModif.Calle == state.calleEdicion &&
                        domModif.Numero == state.alturaEdicion &&
                        domModif.CodigoPostalId == state.codigoPostalId &&
                        domModif.Comentario == state.comentariosDomicilioEdicion &&
                        domModif.Departamento == state.deptoEdicion &&
                        ((domModif.EsDomicilioCorrespondencia && state.tarjeta_prepaga.some(t=>t.Descripcion == "Correspondencia" && t.Check)) || (!domModif.EsDomicilioCorrespondencia && !state.tarjeta_prepaga.some(t=>t.Descripcion == "Correspondencia" && t.Check))) &&
                        ((domModif.EsDomicilioLegal && state.tarjeta_prepaga.some(t=>t.Descripcion == "Legal" && t.Check)) || (!domModif.EsDomicilioLegal && !state.tarjeta_prepaga.some(t=>t.Descripcion == "Legal" && t.Check))) &&
                        domModif.Localidad == state.localidadEdicion &&
                        domModif.PaisId == state.paisId && 
                        domModif.ProvinciaId == state.provinciaId &&
                        domModif.Piso == state.pisoEdicion
                    ){
                        validaCamposEdicion.modificacionesDomicilio = false;
                    }

                }
                break;
            }
        }
        
        let validaciones = Object.keys(validaCamposEdicion);

        let valida = true; 
        
        validaciones.map(val=>{if(validaCamposEdicion[val] == false) valida = false;})
        //FIN VALIDACIONES
        
        if(valida){
            switch(campo){
                case "TELEFONO":{
                        guardarMedioLocalizacion("TELEFONO",true,getState())
                    break;
                }
                case "EMAIL":{
                    let dPrevia = _existeDireccionPrevia(state);
                    let existeDCredito = dPrevia.existeRegistroCredito
                    let existeDPrepaga = dPrevia.existeRegistroPrepaga
                    if(existeDCredito && state.checkProductoCredito || existeDPrepaga && state.checkProductoPrepaga){
                        _dispatch({ type: MODAL_ADVERTENCIA_DIRECCION_EXISTENTE, esModificacion });//action que abre el modal para confirmar el reemplazo de los mails
                    }else{
                        guardarMedioLocalizacion("EMAIL",true,getState())
                    }
                    break;
                }
                case "POSTAL":{
                    let domicilioPrevio = _existeDomicilioPrevio(state);
                    let reemplazoDomicilio = domicilioPrevio != false;
                    
                    if(state.esModificacion && domicilioPrevio){
                        reemplazoDomicilio = false;
                        // if(domicilioPrevio.prepagaDomCorrespondenciaAnterior && domicilioPrevio.prepagaDomCorrespondenciaAnterior.Id != state.domicilioModificacion.Id) reemplazoDomicilio = true;
                        // if(domicilioPrevio.prepagaDomLegalAnterior && domicilioPrevio.prepagaDomLegalAnterior.Id != state.domicilioModificacion.Id) reemplazoDomicilio = true;
                        // if(domicilioPrevio.creditoDomCorrespondenciaAnterior && domicilioPrevio.creditoDomCorrespondenciaAnterior.Id != state.domicilioModificacion.Id) reemplazoDomicilio = true; 
                        // if(domicilioPrevio.creditoDomLegalAnterior && domicilioPrevio.creditoDomLegalAnterior.Id != state.domicilioModificacion.Id) reemplazoDomicilio = true; 
                        let doms = Object.keys(domicilioPrevio);

                        doms.map(d=>{
                            if(domicilioPrevio[d] && domicilioPrevio[d].Id !=  state.domicilioModificacion.Id) reemplazoDomicilio = true;
                        })
                    }
                    
                    if(reemplazoDomicilio){
                        _dispatch({ type: MODAL_ADVERTENCIA_DOMICILIO_EXISTENTE, domicilioPrevio });//action que abre el modal para confirmar el reemplazo de los 
                    }else{
                        guardarMedioLocalizacion("POSTAL",true,getState())
                    }
                    
                    break;
                }
            }    
        }else{// SI NO VALIDA SE GUARDAN LAS VALIDACIONES FALLIDAS EN EL STORE PARA MOSTRAR LAS ADVERTENCIAS 
            _dispatch({ type: ERROR_VALIDACION_LOCALIZACION, validaCamposEdicion });
        }  
    }
}

function _existeDomicilioPrevio(state){

    let obj={
        prepagaDomLegalAnterior:null,
        prepagaDomCorrespondenciaAnterior:null,
        creditoDomLegalAnterior:null,
        creditoDomCorrespondenciaAnterior:null,
    }

    let legalPrepaga = state.tarjeta_prepaga.some(c=>c.Descripcion == "Legal" && c.Check);
    let correspondenciaPrepaga = state.tarjeta_prepaga.some(c=>c.Descripcion == "Correspondencia" && c.Check);
    let legalCredito = state.tarjeta_credito.some(c=>c.Descripcion == "Legal" && c.Check);
    let correspondenciaCredito = state.tarjeta_credito.some(c=>c.Descripcion == "Correspondencia" && c.Check);

    if(state.infoDomiciliosCuenta.length>0){
       let cuentaPrepaga = state.infoDomiciliosCuenta.filter(c=>c.TipoProducto.includes("Prepaga"))
       cuentaPrepaga = cuentaPrepaga[0] ? cuentaPrepaga[0] : null; 
       let cuentaCredito = state.infoDomiciliosCuenta.filter(c=>c.TipoProducto.includes("de"))
       cuentaCredito = cuentaPrepaga[0] ? cuentaPrepaga[0] : null; 

       if(cuentaPrepaga){
           state.domiciliosTotal.map(d=>{
               if(d.Id == cuentaPrepaga.DomicilioCorrespondenciaId) obj.prepagaDomCorrespondenciaAnterior = d;
               if(d.Id == cuentaPrepaga.DomicilioParticularId) obj.prepagaDomLegalAnterior = d;
           })
       }

       if(cuentaCredito){
            state.domiciliosTotal.map(d=>{
                if(d.Id == cuentaCredito.DomicilioCorrespondenciaId) obj.creditoDomCorrespondenciaAnterior = d;
                /*if(d.Id == cuentaCredito.DomicilioParticularId)*/ obj.creditoDomLegalAnterior = d;
            })
       }
       
       if((legalPrepaga && obj.prepagaDomLegalAnterior) || (correspondenciaPrepaga &&  obj.prepagaDomCorrespondenciaAnterior) || (legalCredito && obj.creditoDomLegalAnterior) || (correspondenciaCredito &&  obj.creditoDomCorrespondenciaAnterior) ){
        return obj
       }
       
    }
    return null
}

function _actualizarLocalizacionCliente(clienteId, cerrarModalesAbiertos){
    let paramCliente = {

        'CLIENTE_ID':parseInt(clienteId)
    } 
    Engine1Proxy.AddDataSourcesRequests(paramCliente, 'GET_CONTACTO_BY_ID_CLIENTE', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'Product', true);
    LogHelper.Out(_actualizarLocalizacionCliente.name, paramCliente, 'GET_CONTACTO_BY_ID_CLIENTE', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Socios');
    
    Engine1Proxy.Execute((data) => _actualizarLocalizacionClienteCallback(data, cerrarModalesAbiertos), null, null, "CONSULTASOCIOS");
}

function _actualizarLocalizacionClienteCallback(data, cerrarModalesAbiertos){

    let contacto = JSON.parse(data.GET_CONTACTO_BY_ID_CLIENTE).Recordset0.Rows;

    let contactosSinCuenta = JSON.parse(data.GET_CONTACTO_BY_ID_CLIENTE).Recordset1.Rows;

    contacto = contacto.concat(contactosSinCuenta); //emails con el campo CuentaTarjetaId en NULL
    
    let contactosTotal = JSON.parse(JSON.stringify(contacto));
    
    let arregloLocalizacionContacto = ContactoHelper.ComunicacionHelper(contacto);

    _dispatch({ type: ACTUALIZAR_LOCALIZACION_CLIENTE, arregloLocalizacionContacto, contactosTotal });
    
    if(cerrarModalesAbiertos){
        _dispatch({ type: ABRIR_MODAL_LOCALIZACION, tiposComunicacion:null, medio:null });
        _dispatch({ type: LIMPIAR_EDICIONES });
    } 
}


//FUNCIÓN QUE ABRE EL CONFIRMADOR PARA SALIR DEL MODAL DE EDICIÓN TRAS CLICK EN "CANCELAR"
export function modalConfirmador(accion, invocador){
    LogHelper.In(modalConfirmador.name, accion, invocador);
    return (dispatch,getState)=>{

        _dispatch = dispatch;

        let state = JSON.parse(JSON.stringify(getState()));

        if(accion == "confirmar"){

            switch(invocador){

                case "ELIMINAR":{

                    _eliminarMedioComunicacion(state)
                    break;
                }
            }

            _dispatch({ type: LIMPIAR_EDICIONES });
        }

        dispatch({ type: MODAL_CONFIRMADOR, accion, invocador });
    }
}

//FUNCIÓN PARA INVOCAR LA MODIFICACIÓN DE UN MEDIO DE CONTACTO (LAPIZ)
export function modificarCampoLocalizacion(medio, accion){
    LogHelper.In(modificarCampoLocalizacion.name, medio, accion);
    
    return (dispatch,getState)=>{
        if(accion){
            _dispatch=dispatch;
            let state = getState();
            let cuentaPrepaga = state.cliente.cuenta;
            let cuentaCredito = state.cliente.cuentaCredito;
            let contactos2 = state.cliente.contactosTotal;
            let arregloContactosAModificar = contactos2.filter(con=>con.Id == medio.Id); //es uno solo siempre
            let tipoCuentaModif = arregloContactosAModificar.length > 0 ? arregloContactosAModificar[0].CuentaTarjetaId == cuentaPrepaga.CuentaTarjetaId ? "TP" : null : null;
            //if(!arregloContactosAModificar[0].CuentaTarjetaId) tipoCuentaModif = null;
            
            let tiposProductoPermitidosModificacion = "AMBAS";
            
            switch (medio.MedioNombre){
                case "POSTAL":{
                    let paramDom = {
                        'DOMICILIO_ID':medio.DomicilioId,
                        'CLIENTE_ID': state.cliente.id
                    }

                    //se piden los datos para la modificación únicamente si no se encontraban cargados ya de una acción anterior debido a que son demasiados registros para pedirlos varias veces
                    if(!state.cliente.domicilioComponentes || !state.cliente.domicilioComponentes.codigoPostalRows){

                        Engine1Proxy.AddDataSourcesRequests(paramDom, 'UP_GET_DATOS_ModificacionDomicilioPostal', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true);
                            
                        Engine1Proxy.Execute((data) => _callBackModificarDomicilio(data,medio,state), null, null, "CONSULTASOCIOS");

                    }else{
                        _callBackModificarDomicilio(null,medio,state)
                    }
                    break;
                }
                case "ELECTRONICO":{
                    if(tipoCuentaModif == "TP"){
                        if(!cuentaCredito ||!contactos2.some(c=>c.TipoComunicacionId == 2 && c.CuentaTarjetaId == cuentaCredito.CuentaTarjetaId)) tiposProductoPermitidosModificacion = "TP"
                    }

                    if(tipoCuentaModif == "TC"){
                        if(!cuentaPrepaga ||!contactos2.some(c=>c.TipoComunicacionId == 2 && c.CuentaTarjetaId == cuentaPrepaga.CuentaTarjetaId)) tiposProductoPermitidosModificacion = "TC"
                    }

                    let params={
                        'MEDIO': 'ELECTRONICO'
                    }
                    
                    let params2={
                        'CLIENTE_ID':state.cliente.id
                    } 
                           
                    Engine1Proxy.AddDataSourcesRequests(params2, 'UP_GET_DATOS_AltaDireccionElectronica', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true, 'dataDirecElec');
                    Engine1Proxy.AddDataSourcesRequests(params, 'GET_TIPOS_COMUNICACION_BY_MEDIO', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true, 'tiposComunicacion');
                    Engine1Proxy.Execute((data) => _callBackModificarCampoLocalizacion(data,medio,arregloContactosAModificar,tiposProductoPermitidosModificacion), null, null, "CONSULTASOCIOS"); 
                    break;
                }
                case "TELEFONICO":{

                    if(medio.TipoComunicacionId == 3){
                        if(tipoCuentaModif == "TP"){
                           if(!cuentaCredito || !contactos2.some(c=>c.TipoComunicacionId == 3 && c.CuentaTarjetaId == cuentaCredito.CuentaTarjetaId)) tiposProductoPermitidosModificacion = "TP"
                        }
    
                        if(tipoCuentaModif == "TC"){
                            if(!cuentaPrepaga || !contactos2.some(c=>c.TipoComunicacionId == 3 && c.CuentaTarjetaId == cuentaPrepaga.CuentaTarjetaId)) tiposProductoPermitidosModificacion = "TC"
                        }
    
    
                        let params={
                            'MEDIO': 'TELEFONICO'
                        }
                        
                        Engine1Proxy.AddDataSourcesRequests(params, 'GET_TIPOS_COMUNICACION_BY_MEDIO', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true, 'tiposComunicacion');
                        Engine1Proxy.Execute((data) => _callBackModificarCampoLocalizacion(data,medio,arregloContactosAModificar,tiposProductoPermitidosModificacion), null, null, "CONSULTASOCIOS"); 
                    }else if(medio.TipoComunicacionId == 4){
                        if(tipoCuentaModif == "TP"){
                            if(!cuentaCredito || !contactos2.some(c=>c.TipoComunicacionId == 4 && c.CuentaTarjetaId == cuentaCredito.CuentaTarjetaId)) tiposProductoPermitidosModificacion = "TP"
                        }
    
                        if(tipoCuentaModif == "TC"){
                            if(!cuentaPrepaga || !contactos2.some(c=>c.TipoComunicacionId == 4 && c.CuentaTarjetaId == cuentaPrepaga.CuentaTarjetaId)) tiposProductoPermitidosModificacion = "TC"
                        }
    
    
                        let params={
                            'MEDIO': 'TELEFONICO'
                        }
                          
                        Engine1Proxy.AddDataSourcesRequests(params, 'GET_TIPOS_COMUNICACION_BY_MEDIO', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true, 'tiposComunicacion');
                        Engine1Proxy.Execute((data) => _callBackModificarCampoLocalizacion(data,medio,arregloContactosAModificar,tiposProductoPermitidosModificacion), null, null, "CONSULTASOCIOS"); 
                    }
                }
 
                    break;
            }

        }else{
            dispatch({ type: ABRIR_MODAL_LOCALIZACION, tiposComunicacion:null, medio:null });
            dispatch({ type: LIMPIAR_EDICIONES });
        }
    }
}


export function _callBackModificarDomicilio(data, medio){
    let domicilioComponentes;

    //SI DATA VIENE EN NULL ES PORQUE NO SE PIDIERON A LA BASE LOS DATOS DE CODIGO POSTAL, PROVINCIA Y PAIS PORQUE YA SE ENCONTRABAN EN EL STORE
    if(data){
        domicilioComponentes = {
            codigoPostalRows:  JSON.parse(data.UP_GET_DATOS_ModificacionDomicilioPostal).Recordset0.Rows,
            provinciaRows:  JSON.parse(data.UP_GET_DATOS_ModificacionDomicilioPostal).Recordset1.Rows,
            paisRows:  JSON.parse(data.UP_GET_DATOS_ModificacionDomicilioPostal).Recordset2.Rows
         }
    }

    let checks = {
        prepaga:{
            legal: false,
            correspondencia:false
        },
        credito:{
            legal: false,
            correspondencia:false
        }
    }

    if(medio.TipoProducto == "Tarjeta Prepaga" || medio.TipoProducto == "ambas"){
        checks.prepaga.legal = medio.EsDomicilioLegal;
        checks.prepaga.correspondencia = medio.EsDomicilioCorrespondencia;
    }

    
    _dispatch({ type: ABRIR_MODAL_DOMICILIO_MODIFICACION, domicilioComponentes, medio, checks});
}

function _callBackModificarCampoLocalizacion(data,medio,arregloContactosAModificar,tiposProductoPermitidosModificacion){
    
    let tiposComunicacion = JSON.parse(data.tiposComunicacion).Recordset0.Rows;
    let infoCuentas= null;
    let emailCuentasActuales=null;
    
    if(![1,3,4].some(m=>m == medio.TipoComunicacionId) ){
        let medioMod = arregloContactosAModificar[0];
        if(!medioMod.CuentaTarjetaId){
            tiposProductoPermitidosModificacion = "TP"
        }

        infoCuentas = JSON.parse(data.dataDirecElec).Recordset1.Rows;
        if(infoCuentas.some(c=>c.Email != null)){
            emailCuentasActuales = {};
            infoCuentas.map(cuenta=>{
                if(cuenta.Email){
                    emailCuentasActuales[cuenta.TipoCuenta] = {}
                    emailCuentasActuales[cuenta.TipoCuenta].Contacto =  cuenta.Email
                    emailCuentasActuales[cuenta.TipoCuenta].Id =  cuenta.EmailId                   
                } 
            })
        }
    }
    
    _dispatch({ type: ABRIR_MODAL_LOCALIZACION_MODIFICACION, tiposComunicacion, medio,arregloContactosAModificar,tiposProductoPermitidosModificacion, infoCuentas, emailCuentasActuales});
    
}

//FUNCIÓN PARA INVOCAR LA ELIMINACIÓN DE UN MEDIO DE CONTACTO (TACHO)
export function eliminarMedioDeContacto(medio,accion, esDomicilio){
    LogHelper.In(eliminarMedioDeContacto.name, medio, accion);
    
    return (dispatch,getState)=>{
        if(accion){
            _dispatch=dispatch;
            let state = getState();
            let arregloContactosAEliminar = !esDomicilio ? state.cliente.contactosTotal.filter(con=>con.Contacto == medio.Contacto) : state.cliente.domiciliosTotal.filter(d=>d.Id == esDomicilio);
            if(arregloContactosAEliminar[0] && arregloContactosAEliminar[0].EsDomicilioLegal){
                _dispatch({ type: ABRIR_MODAL_ADVERTENCIA_DOMICILIO_LEGAL});
            }else{
                _dispatch({ type: ABRIR_MODAL_LOCALIZACION_ELIMINAR, medio, arregloContactosAEliminar});
            }
        }else{
            dispatch({ type: ABRIR_MODAL_LOCALIZACION, tiposComunicacion:null, medio:null });
            dispatch({ type: LIMPIAR_EDICIONES });
        }
    }
}

function _eliminarMedioComunicacion(state){
    let mediosEliminar = state.cliente.mediosLocalizacionEliminar;
    
    if(mediosEliminar.some(medio=>medio.TipoProducto == "Tarjeta Prepaga" && medio.TipoComunicacionId <5)){
        let cuentaEntidadNumero = state.cliente.cuenta.CuentaEntidadNumero;
        let producto = state.cliente.cuenta.codigoProducto;
        let body = "";
        let medioPrepagaEliminar = mediosEliminar.filter(medio=>medio.TipoProducto == "Tarjeta Prepaga")[0];
        debugger
        switch (medioPrepagaEliminar.TipoComunicacionId){
            case 1:{

                body = '{"DomicilioCorrespondencia" : {'  
                +'"Calle":"' + '\xa0' + '",'
                +'"Altura":"' + '\xa0' + '",'
                +'"Piso":"' + '\xa0' + '",'
                +'"Departamento":"' + '\xa0' + '",'
                +'"CodigoPostal":"' + '\xa0' + '",'
                +'"Localidad":"' + '\xa0' + '",'
                +'"Provincia":"' + '\xa0' + '",'
                +'"Pais":"' + '\xa0' + '",'
                +'"Comentario":"' + '\xa0' + '"'
                +'}}';

                break;
            }
            case 2:{
                body = '{'+ '"Email" : ' + '"' +'\xa0' + '"' + '}';
                break;
            }
            case 3:
            case 4:{

                let mediosTotal = state.cliente.contactosTotal;
                let celularActual= '"'+'\xa0'+'"';
                let telefonoActual= '"'+'\xa0'+'"';

                mediosTotal.map(m=>{
                    if(m.TipoProducto == "Tarjeta Prepaga"){
                        if(m.TipoComunicacionId == 3 && m.Id != medioPrepagaEliminar.Id) celularActual = '"'+m.Contacto+'"';
                        if(m.TipoComunicacionId == 4 && m.Id != medioPrepagaEliminar.Id) telefonoActual = '"'+m.Contacto+'"';
                    }
                })
                
                body = '{'
                + '"Telefonos":{'
                +  '"Particular":'+ (telefonoActual)
                +","
                +  '"Celular":'+ (celularActual) 
                + '}}';
                break;
            }
        }

        let paramCuentas = {
            'numeroCuenta': cuentaEntidadNumero,
            'idProducto': producto,
            'body': body
        }  
        
        Engine1Proxy.AddDataSourcesRequests(paramCuentas, 'MODIFICAR_CUENTA', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true, 'modificacionCuenta');
        Engine1Proxy.Execute((data) => eliminarMediosBase(data,state), null, null, "CONSULTASOCIOS");
        
    }else{
        eliminarMediosBase(null,state)
    }
}

function eliminarMediosBase(data,state){
    
    if(data){//en este caso la función se llamó luego de enviar los cambios a GP
        var GpRespuesta = JSON.parse(data.modificacionCuenta).Recordset0.Rows[0];
        
        if (!GpRespuesta.IsError) {
            let mediosEliminar = state.cliente.mediosLocalizacionEliminar;
            let usuario = state.sesion.executionContext.login;
            let cuentaPrepagaId = state.cliente.cuenta.CuentaTarjetaId;

            if(mediosEliminar.some(m=>m.TipoComunicacionId == 1)){

                let domicilioEliminar = mediosEliminar[0];

                let paramsEventSourcingDomicilio={
                    "ACTIVO":0,
                    "FECHA_ULTIMA_MODIFICACION": new Date()
                }

                let paramsModifCuentaTarjeta = {
                    "DOMICILIO_CORRESPONDENCIA_ID":null
                }

                let paramsDomicilioLogElim = {
                    "DOMICILIO_ID":domicilioEliminar.Id,
                    "CLIENTE_ID":state.cliente.id,
                    "CALLE":domicilioEliminar.Calle,
                    "NUMERO":domicilioEliminar.Numero,
                    "DEPARTAMENTO":domicilioEliminar.Departamento,
                    "PISO":domicilioEliminar.Piso,
                    "LOCALIDAD":domicilioEliminar.Localidad,
                    "PROVINCIA_ID":domicilioEliminar.ProvinciaId,
                    "CODIGO_POSTAL":domicilioEliminar.CodigoPostal,
                    "PAIS_ID":domicilioEliminar.PaisId,
                    "COMENTARIO":domicilioEliminar.Comentario,
                    "PREPAGA_CORRESP_ID": cuentaPrepagaId,
                    "TIPO_OPERACION":"B",
                    "FECHA_HORA_OPERACION":new Date(),
                    "USUARIO_OPERACION": state.sesion.executionContext.login
                }
                
                Engine1Proxy.AddEventSourcingDataRequest(paramsDomicilioLogElim, "EVENTSOURCING_TRANSACTION_DOMICILIO_LOG", 'Tarjetas', "ADMINEMPCUETAR", null, true, null, false,null);
                Engine1Proxy.AddEventSourcingDataRequest(paramsModifCuentaTarjeta, "EVENTSOURCING_TRANSACTION_CUENTA_TARJETA", 'Tarjetas', "ADMINEMPCUETAR", null, true, null, false,cuentaPrepagaId);
                Engine1Proxy.AddEventSourcingDataRequest(paramsEventSourcingDomicilio, "EVENTSOURCING_TRANSACTION_DOMICILIO", 'Tarjetas', "ADMINEMPCUETAR", null, true, null, false,domicilioEliminar.Id);

            }else{
                mediosEliminar.forEach((medio, index) => {
                    
                    //PARÁMETROS EVENTSOURCING
                    let localValues = {
                        "TIPO_COMUNICACION_ID": medio.TipoComunicacionId,
                        "CUENTA_TARJETA_ID": state.cliente.cuenta.CuentaEntidadNumero,//ver
                        "CONTACTO": medio.Contacto,
                        "CLIENTE_ID": state.cliente.id
                    }
                    
            
                    let isQuery = false;
                    let deleteInstance = true;
    
                    //PARÁMETROS INSERT TABLA LOG
                    let param = {
                        'FORMA_COMUNICACION_ID': medio.Id,
                        'TIPO_COMUNICACION_ID': medio.TipoComunicacionId,
                        'CUENTA_TARJETA_ID': state.cliente.cuenta.CuentaTarjetaId,
                        'CLIENTE_ID': state.cliente.id,
                        'CONTACTO': medio.Contacto,
                        'TIPO_OPERACION': "B",
                        'USUARIO_OPERACION': usuario
                    }  
    
                    //Engine1Proxy.AddDataSourcesRequests(param, 'UP_INSERTAR_FORMA_COMUNICACION_LOG', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true, 'InsertFormaComunicacionLog');
                    Engine1Proxy.AddEventSourcingDataRequest(param, "EVENTSOURCING_TRANSACTION_FORMA_COMUNICACION_LOG", 'Tarjetas', "ADMINEMPCUETAR", null, true, null,false, null);
                    Engine1Proxy.AddEventSourcingDataRequest(localValues, "EVENTSOURCING_TRANSACTION_FORMA_COMUNICACION", 'Tarjetas', "ADMINEMPCUETAR", index, isQuery, null, deleteInstance, medio.Id);
                });
            }
        
            Engine1Proxy.Execute(()=>_actualizarLocalizacionCliente(state.cliente.id), null, null, "ADMINEMPCUETAR");

        }else{
            _dispatch({ type: INTENTOS_AGOTADOS_GUARDADO_GLOBAL });
        }
    
    }else{//la función se llamó desde la action de eliminar sin pasar por GP porque no era una cuenta prepaga
        let mediosEliminar = state.cliente.mediosLocalizacionEliminar;
        let usuario = state.sesion.executionContext.login;
        
        if(mediosEliminar.some(m=>m.TipoComunicacionId == 1)){

            let domicilioEliminar = mediosEliminar[0];
            let paramsEventSourcingDomicilio={
                "ACTIVO":0,
                "FECHA_ULTIMA_MODIFICACION": new Date()
            }
            
            Engine1Proxy.AddEventSourcingDataRequest(paramsEventSourcingDomicilio, "EVENTSOURCING_TRANSACTION_DOMICILIO", 'Tarjetas', "ADMINEMPCUETAR", null, true, null, false,domicilioEliminar.Id);
        }else{
            mediosEliminar.forEach((medio, index) => {
    
                //PARÁMETROS EVENTSOURCING   
                let localValues = {
                    "TIPO_COMUNICACION_ID": medio.TipoComunicacionId,
                    "CUENTA_TARJETA_ID": state.cliente.cuenta.CuentaEntidadNumero,//ver
                    "CONTACTO": medio.Contacto,
                    "CLIENTE_ID": state.cliente.id
                }
        
                let isQuery = false;
                let deleteInstance = true;
                
                 //PARÁMETROS INSERT TABLA LOG
                let param = {
                    'FORMA_COMUNICACION_ID': medio.Id,
                    'TIPO_COMUNICACION_ID': medio.TipoComunicacionId,
                    'CUENTA_TARJETA_ID': state.cliente.cuenta.CuentaTarjetaId,
                    'CLIENTE_ID': state.cliente.id,
                    'CONTACTO': medio.Contacto,
                    'TIPO_OPERACION': "B",
                    'USUARIO_OPERACION': usuario
                }  
        
                //Engine1Proxy.AddDataSourcesRequests(param, 'UP_INSERTAR_FORMA_COMUNICACION_LOG', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true, 'InsertFormaComunicacionLog');
                Engine1Proxy.AddEventSourcingDataRequest(param, "EVENTSOURCING_TRANSACTION_FORMA_COMUNICACION_LOG", 'Tarjetas', "ADMINEMPCUETAR", null, true, null,false, null);
        
                Engine1Proxy.AddEventSourcingDataRequest(localValues, "EVENTSOURCING_TRANSACTION_FORMA_COMUNICACION", 'Tarjetas', "ADMINEMPCUETAR", index, isQuery, null, deleteInstance, medio.Id);
            });
        }
        
        Engine1Proxy.Execute(()=>_actualizarLocalizacionCliente(state.cliente.id), null, null, "ADMINEMPCUETAR");
    }

}

function callbackEliminarMediosBase(clienteId){
    let paramCliente = {
        'CLIENTE_ID':parseInt(clienteId)
    }
    
    Engine1Proxy.AddDataSourcesRequests(paramCliente, 'GET_CONTACTO_BY_ID_CLIENTE', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'Product', true);

    Engine1Proxy.Execute((data) => _actualizarLocalizacionClienteCallback(data), null, null, "CONSULTASOCIOS");
}


///////////////////// FUNCIONES NOVEDADES ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


export function editandoCampo(campo, valor, valorNovedadModificada, seccion,cierra) {
    LogHelper.In(editandoCampo.name, campo, valor, valorNovedadModificada, seccion,cierra);
    let valorDefaultSelect = valorNovedadModificada ? valorNovedadModificada : valor;
    return (dispatch, getState) => {
    dispatch({ type: EDITANDO_CAMPO_CLIENTE, campo, valor: valorDefaultSelect, seccion,cierra });
    }
}

export function limpiarStoreComponente(campo,seccion) {
    LogHelper.In(limpiarStoreComponente.name, campo,seccion);
    
    return (dispatch, getState) => {
    dispatch({ type: LIMPIAR_STORE_COMPONENTE_CLIENTE, campo });
    }
}


export function guardarNovedad(valorOriginal, seccion,tarjetaId) {
    LogHelper.In(guardarNovedad.name, valorOriginal, seccion,tarjetaId);

    

    return (dispatch, getState) => {
        let state = getState();
        state = JSON.parse(JSON.stringify(state));
        
        let puedeGuardar = true;
        let parametroGeneral = state.cliente.parametroGeneral;
        let entidadTipo = 4; 
        let novedadTipo = 4; 
        
        const componenteSeleccionado = state.cliente.editandoCampo;
        
        let errorValid = errorValidacion(state,componenteSeleccionado);
                
        if (puedeGuardar && !errorValid) {
            let novedad = {};
            let novedades = [];
            let novedadesCuentaDatos = state.cliente.novedades;
            let novedadAnterior = valorOriginal;
            let novedadObtenida;
            let  CuentaTarjetaId  = null;
            const { executionContext } = state.sesion;
            let confirmacionNecesaria = false;

            if(parametroGeneral.SINOCONFIRMACIONMODIFCLIENTE && !["EDOCIVIL_CLIE","NACION_CLIE", "CONDIVA_CLIE","ACTIV_CLIE"].some(c=>c==componenteSeleccionado)){
                confirmacionNecesaria = true;
            }

            novedadObtenida = novedadesCuentaDatos.find(x => x.NovedadCampoCodigo == componenteSeleccionado && x.NovedadEstadoId < 3);

            novedad = {
                ...novedad,
                ClienteId: state.cliente.id, 
                EstadoId: confirmacionNecesaria ? 1 :2,
                CuentaTarjetaId: CuentaTarjetaId,
                TipoEntidad: novedadTipo,
                Id: novedadObtenida ? novedadObtenida.Id : null,
                Codigo: componenteSeleccionado,
                ValorAnterior: novedadAnterior,
                ValorNovedad: state.cliente[componenteSeleccionado],
                UsuarioLogin: executionContext.login,
                Terminal: executionContext.terminalId,
                tipoEntidad: entidadTipo,
                UsuarioLoginConf: confirmacionNecesaria ? null : executionContext.login,
                deleteInstance: null,
                TarjetaCreditoId:tarjetaId ? tarjetaId : null,
                FechaInterfazAdministradora: new Date() 

            }
            
            novedades.push(novedad);
            _dispatch({ type: LOADING_CLIENTE });
            _dispatch({
                type: MOSTRAR_SPINNER
            });
            _dispatch({
                type: CAMPO_EN_PROCESO, campo: componenteSeleccionado
            });
            
            NovedadesManager.GuardarNovedades(novedades, () => callBackGuardarNovedad(state,novedad, seccion,CuentaTarjetaId));
        }
        else {
            _dispatch({
                type: MOSTRAR_ERROR_VALIDACION,
                mensaje: errorValid,
                campo: componenteSeleccionado
            });
        }

    }
}


function callBackGuardarNovedad(state,novedad, seccion,CuentaTarjetaId) {
    LogHelper.In(callBackGuardarNovedad.name, state,novedad, seccion);
    let novedadTipo = 4; 
    
    let param = {
        'CLIENTE_ID':parseInt(state.cliente.id)
    }
    
    Engine1Proxy.AddDataSourcesRequests(param, 'GET_NOVEDADES_BY_CLIENTE_ID', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'Product', true);
    LogHelper.Out(getScreenData.name, param, 'GET_NOVEDADES_BY_CLIENTE_ID', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Socios');

    Engine1Proxy.Execute((data) => _loadGetNovedades(data, state,novedad, seccion), null, null, "ADMINEMPCUETAR");
}

function errorValidacion(state,campo){

    let respuesta = false;
    let storeCliente = state.cliente;

    switch (campo){
        case "NRODOCUM_CLIE":{
            if(!respuesta && !_validarCampo(storeCliente[campo])) respuesta = "Campo obligatorio";
            if(!respuesta && !(storeCliente[campo].length > 4 && storeCliente[campo].length < 9)) respuesta = "El largo del número debe ser entre 5 y 8 caracteres";
            if(!respuesta && !(/^[0-9]*$/.test(storeCliente[campo]))) respuesta = "Se han ingresado caracteres no permitidos";
            break;
        }
        case "CUIT_CLIE":{
            if(!respuesta && !_validarCampo(storeCliente[campo])) respuesta = "Campo obligatorio";
            if(!respuesta && !(storeCliente[campo].length == 11)) respuesta = "El largo debe ser de 11 caracteres";
            if(!respuesta && !(/^[0-9]*$/.test(storeCliente[campo]))) respuesta = "Se han ingresado caracteres no permitidos";
            break;
        }
        case "FNACIM_CLIE":{
            let strFecha = storeCliente[campo];
            if(strFecha){
                let fecha = strFecha.length == 10 ? GlobalHelper.ConvertirFecha(strFecha) : false;
                let fechaActual = new Date();
                let edad =  fecha ? (fechaActual.getFullYear() - fecha.getFullYear()) : 0;
                
                if(!fecha) respuesta = "La fecha debe estar en formato DD/MM/AAAA";
                if(!respuesta && (strFecha[2] != "/" || strFecha[5] != "/")) respuesta = "La fecha debe estar en formato DD/MM/AAAA";
                if (!respuesta && fecha == "Invalid Date") respuesta = "La fecha no es válida";
                if(!respuesta && fecha > fechaActual) respuesta = "La fecha no puede ser posterior al día actual";
                if(!respuesta &&  edad < 1) respuesta = "La fecha no es válida";
                if(!respuesta &&  edad > 120) respuesta = "La edad máxima es 120 años";
            }else{
                respuesta = "Campo obligatorio";
            }
            break;
        }
    }
    
    return respuesta;
}

export function errorValidacionGuardado(campo){
    return (dispatch,getState)=>{
        let state = getState();
        return errorValidacion(state,campo)
    }
}


function _loadGetNovedades(data, state, novedad, seccion) {
    LogHelper.In(_loadGetNovedades.name, data, state, novedad, seccion);
    
    let entidadId = 4;
    let parametroGeneral = state.cliente.parametroGeneral;

    let novedades = JSON.parse(data.GET_NOVEDADES_BY_CLIENTE_ID).Recordset0.Rows;

    let propNovedades;

    let confirmacionNecesaria = false;

    if(parametroGeneral.SINOCONFIRMACIONMODIFCLIENTE && !["EDOCIVIL_CLIE","NACION_CLIE", "CONDIVA_CLIE","ACTIV_CLIE"].some(c=>c==novedad.Codigo)){
        confirmacionNecesaria = true;
    }
    
    ////////ESTO SE HACE PARA ASIGNAR UN ESTADO "ESPECIAL" A ESTAS NOVEDADES PARA QUE SE MUESTREN UNA SOLA VEZ COMO DENEGADAS O RECHAZADAS
    if( state.cliente.novedadRechazadaId && state.cliente.novedadRechazadaId.length > 0){
        novedades.map(nov=>{
            if(nov.NovedadEstadoId == 6 && state.cliente.novedadRechazadaId.some(rec=>rec== nov.Id) && !novedades.some(n2=>n2.Codigo == nov.Codigo && n2.NovedadEstadoId == 1)) nov.NovedadEstadoId = 21;
        })
    }

    if( state.cliente.novedadDenegadaId && state.cliente.novedadDenegadaId.length > 0){
        novedades.map(nov=>{
            if(nov.NovedadEstadoId == 3 && state.cliente.novedadDenegadaId.some(rec=>rec== nov.Id) && !novedades.some(n2=>n2.Codigo == nov.Codigo && n2.NovedadEstadoId == 1)) nov.NovedadEstadoId = 22;
        })
    }
    novedades.map(nove=>{
        if(nove.NovedadEstadoId > 20){
            if(novedades.some(n2=>n2.Codigo == nove.Codigo && n2.Id>nove.Id)) nove.NovedadEstadoId = nove.NovedadEstadoId == 21 ? 6 : 3;
        }
    })
    /////////
    
    _dispatch({
        type: SAVE_NOVEDAD_CLIENTE,
        data: novedades,
        entidadId: entidadId
    });
    

     if(!confirmacionNecesaria){
        _dispatch({
            type: LOADING_CLIENTE
        });
         let novedadActual
         novedades.map(nov=>{
             if(nov.NovedadCampoCodigo == novedad.Codigo && nov.NovedadEstadoId == 2) novedadActual = nov;
         })
         
         sendCambioAProcesadora(novedadActual.Id, 2, novedad.Codigo, novedad.TipoEntidad, entidadId, state, novedadActual.ValorAnterior,novedad, seccion)
     }else{
        _dispatch({
            type: CAMPO_EN_PROCESO, campo: null
        });
     }     
}


function sendCambioAProcesadora(novedadId, estadoId, novedadCodigo, novedadTipoId, entidadId, state, valorAnterior,ultimaNovedad, seccion) {
    
    LogHelper.In(sendCambioAProcesadora.name, entidadId, estadoId, valorAnterior);
    var body = "";
    _cambioEnviado = true;
    let ultimaNovedadAux = JSON.parse(JSON.stringify(ultimaNovedad));
    if(Array.isArray(ultimaNovedadAux)) ultimaNovedadAux = ultimaNovedadAux[0];
    if(!_cambioEnviado) _dispatch(actualizarNovedadEstado(novedadId, estadoId, novedadCodigo, novedadTipoId, entidadId, seccion));
    _cambioEnviado = true;
    switch (novedadCodigo) {
        case 'NOMBRE_CLIE':
            body = '{'
                + '"Nombre" : ' + '"' + ultimaNovedadAux.ValorNovedad.toString() + '"'
                + '}';
            break;
        case 'APELLIDO_CLIE':
            body = '{'
                + '"Apellido" : ' + '"' + ultimaNovedadAux.ValorNovedad.toString() + '"'
                + '}';
            break;
        case 'NRODOCUM_CLIE':
            body = '{'
                + '"DocumentoNumero" : ' + '"' + ultimaNovedadAux.ValorNovedad.toString() + '"'
                + '}';
            break;
        case 'TIPODOCUM_CLIE':
            body = '{'
                + '"DocumentoTipo" : ' + '"' + ultimaNovedadAux.ValorNovedad.toString() + '"'
                + '}';
            break;
        case 'CUIT_CLIE':
            body = '{'
                + '"DocumentoOtro" : ' + '"' + ultimaNovedadAux.ValorNovedad.toString() + '"'
                + '}';
            break;
        case 'FNACIM_CLIE':
            body = '{'
                + '"FechaNacimiento" : ' + '"' + ultimaNovedadAux.ValorNovedad.toString() + '"'
                + '}';
            break;
        case 'SEXO_CLIE':
            body = '{'
                + '"Sexo" : ' + '"' + ultimaNovedadAux.ValorNovedad.toString() + '"'
                + '}';
            break;
        case 'EDOCIVIL_CLIE'://
            body = '{'
                + '"EstadoCivil" : ' + '"' + ultimaNovedadAux.ValorNovedad.toString() + '"'
                + '}';
            break;
        case 'NACION_CLIE':
            body = '{'
                + '"Nacionalidad" : ' + '"' + ultimaNovedadAux.ValorNovedad.toString() + '"'
                + '}';
            break;
        case 'CONDIVA_CLIE'://
            body = '{'
                + '"CategoriaIvaId" : ' + '"' + ultimaNovedadAux.ValorNovedad.toString() + '"'
                + '}';
            break;
        case 'ACTIV_CLIE':
            body = '{'
                + '"OcupacionId" : ' + '"' + ultimaNovedadAux.ValorNovedad.toString() + '"'
                + '}';
            break;
       
        default:
            break;
    }
    
    let paramCuentas = { 
        'numeroCuenta': state.cliente.cuenta.CuentaEntidadNumero,
        'idProducto': state.cliente.cuenta.codigoProducto,
        'body': body
    }

    _dispatch({ type: LOADING_CLIENTE });
    _dispatch({
        type: CAMPO_EN_PROCESO, campo: novedadCodigo
    });
    

    Engine1Proxy.AddDataSourcesRequests(paramCuentas, 'MODIFICAR_CUENTA', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true, 'clientesObtenidosCuenta');
    Engine1Proxy.Execute((data) => _callBacksendCambioAProcesadora(data, novedadId, novedadCodigo, novedadTipoId, entidadId, state, valorAnterior,ultimaNovedad, seccion), null, null, "CONSULTASOCIOS");

};


export function actualizarNovedadEstado(novedadId, estadoId, novedadCodigo, novedadTipoId, entidadId, seccion) {
    LogHelper.In(actualizarNovedadEstado.name, novedadId, estadoId);
    
    return (dispatch, getState) => {
        _dispatch = dispatch;
        const state = getState();


        const novedadesAux = state.cliente.novedades;
        let valorAnterior = novedadesAux.map(n=>{if(n.Id == novedadId)return n.ValorAnterior})[0];
        let ultimaNovedad = JSON.parse(JSON.stringify(novedadesAux.filter(n=> n.Id == novedadId)));
        let cuentaTarjetaId = null;
        let clienteId = state.cliente.id;
        _ultimaNovedad = ultimaNovedad;

        const { executionContext } = state.sesion;
        let novedad = {};
        let novedades = [];
        novedad.Id = novedadId;
        novedad.Codigo = novedadCodigo;
        novedad.UsuarioLogin = executionContext.login;
        novedad.Terminal = executionContext.terminalId;
        novedades.push(novedad);
        
        dispatch({ type: LOADING_CLIENTE });
        _dispatch({
            type: CAMPO_EN_PROCESO, campo: novedadCodigo
        });
        
        EstadoManager.CambiarEstadoNovedad(novedad, estadoId, () => {
            getNovedadesClienteId(clienteId);
            if (estadoId == 2){
                
                sendCambioAProcesadora(novedadId, 4, novedadCodigo, novedadTipoId, entidadId, state , valorAnterior,ultimaNovedad, seccion);
            }else if(estadoId ==3){
                _dispatch({
                    type: DENIEGA_NOVEDAD_CLIENTE,
                    novedadId,
                    seccion
                });
            }      
        });
    }
}

function _callBacksendCambioAProcesadora(data, novedadId, novedadCodigo, novedadTipoId, entidadId, state, valorAnterior,ultimaNovedad, seccion) {
    
    LogHelper.In(_callBacksendCambioAProcesadora.name, entidadId, novedadCodigo);

    var clienteCuentaRespuesta = JSON.parse(data.clientesObtenidosCuenta).Recordset0.Rows[0];
    
    if (!clienteCuentaRespuesta.IsError) {

        let localValues = mapearCuentaTarjeta(ultimaNovedad);
        const id = state.cliente.id;
        const isQuery = false;
        const deleteInstance = false;
        let campo =  _mapearCampoSegunCodigo(novedadCodigo);
        let valor = ultimaNovedad[0] ? ultimaNovedad[0].ValorNovedad : ultimaNovedad.ValorNovedad;

        Engine1Proxy.AddEventSourcingDataRequest(localValues
            , 'EVENTSOURCING_TRANSACTION_CLIENTE'
            , 'Tarjetas'
            , 'ADMINEMPCUETAR'
            , null
            , isQuery
            , null
            , deleteInstance
            , id);                


        Engine1Proxy.Execute((data) => { }, null, null, "ADMINEMPCUETAR");
        _dispatch(actualizarNovedadEstado(novedadId, 5, novedadCodigo, novedadTipoId, entidadId, seccion));
        _dispatch({
            type: ACEPTA_ADMINISTRADORA_CLIENTE,
            campo,
            valor,
            novedadId
        });
       
        

    } else {
        _dispatch(actualizarNovedadEstado(novedadId, 6, novedadCodigo, novedadTipoId, entidadId, seccion));
        let campo = _mapearCampoSegunCodigo(novedadCodigo);
        let valor = valorAnterior;
        
        _dispatch({
            type: RECHAZA_ADMINISTRADORA_CLIENTE,
            novedadId,
            seccion
        });
    }
};


function mapearCuentaTarjeta(ultimaNovedad) {

    let now = new Date();
    let values;
    let novAux = ultimaNovedad;
    if(Array.isArray(ultimaNovedad)) novAux = ultimaNovedad[0];

        switch (novAux.Codigo) {//CAMBIAR POR LO QUE CORRESPONDA
            case 'NOMBRE_CLIE':
                values = {
                    "NOMBRE": novAux.ValorNovedad
                };
                break;
            case 'APELLIDO_CLIE':
                values = {
                    "APELLIDO": novAux.ValorNovedad
                };
                break;
            case 'NRODOCUM_CLIE':
                values = {
                    "NUMERO_DOCUMENTO": novAux.ValorNovedad
                };
                break;
            case 'TIPODOCUM_CLIE':
                values = {
                    "TIPO_DOCUMENTO_ID": novAux.ValorNovedad
                };
                break;
            case 'CUIT_CLIE':
                values = {
                    "CUIT": novAux.ValorNovedad
                };
                break;
            case 'FNACIM_CLIE':
                values = {
                    "FECHA_NACIMIENTO": GlobalHelper.ConvertirFecha(novAux.ValorNovedad)
                };
                break;
            case 'SEXO_CLIE':
                values = {
                    "SEXO": novAux.ValorNovedad
                };
                break;
            case 'EDOCIVIL_CLIE':
                values = {
                    "ESTADO_CIVIL_ID": novAux.ValorNovedad
                };
                break;
            case 'NACION_CLIE':
                values = {
                    "NACIONALIDAD_ID": novAux.ValorNovedad
                };
                break;
            case 'CONDIVA_CLIE':
                values = {
                    "CATEGORIA_IVA_ID": novAux.ValorNovedad
                };
                break;
            case 'ACTIV_CLIE':
                values = {
                    "OCUPACION_ID": novAux.ValorNovedad
                };
                break;

            default:
                break;
        }    
    return values;
}


export function selectValorCampo(codigo,valor, seccion) {
    LogHelper.In(selectValorCampo.name, codigo,valor, seccion);
    
    let valorAux = valor;

    switch(codigo){

        case 'DENOM_TARJ':{// ARREGLAR
            let regEx= /^[a-zA-ZñÑáÁéÉíÍóÓúÚ.\s]{1,26}$/
            if(!regEx.test(valor) && valor !=""){
                valorAux = null;
            }
            break;
        }     
        case 'CRLIN_TARJ':{
            
            let regEx= /^[a-zA-Z0-9ñÑáÁéÉíÍóÓúÚ.\s]{1,26}$/

            if(!regEx.test(valor) && valor !=""){
                valorAux = null;
            }
            break;
        }
    }
        return (dispatch, getState) => {
            _dispatch = dispatch;
            dispatch({
                type: SELECCIONAR_VALOR_CAMPO_CLIENTE,
                codigo,
                valor : valorAux,
                seccion
            });
        }
}

function getNovedadesClienteId(clienteId) {
    LogHelper.In(getNovedadesClienteId.name,clienteId);

    let param = {
        'CLIENTE_ID':parseInt(clienteId)
    }
    
    Engine1Proxy.AddDataSourcesRequests(param, 'GET_NOVEDADES_BY_CLIENTE_ID', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'Product', true);
    LogHelper.Out(getScreenData.name, param, 'GET_NOVEDADES_BY_CLIENTE_ID', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Socios');
    

    Engine1Proxy.Execute((data) => callbackGetNovedadesClienteId(data), null, "ADMINEMPCUETAR");
}


function callbackGetNovedadesClienteId(data) {
    let novedades = JSON.parse(data.GET_NOVEDADES_BY_CLIENTE_ID).Recordset0.Rows;
    let novedadesCanceladas = [];
    
    _dispatch({ type: ACTUALIZAR_ESTADO_NOVEDAD_CLIENTE, novedades, novedadTipoId : 4 });
}

function _mapearCampoSegunCodigo(codigo){
    let campo = "";

    switch(codigo){ //ARREGLAR
            
        case 'NOMBRE_CLIE':
            campo = "Nombre";
            break;
        case 'APELLIDO_CLIE':
            campo = "Apellido";
            break;
        case 'NRODOCUM_CLIE':
            campo = "DocumentoNumero";
            break;
        case 'TIPODOCUM_CLIE':
            campo = "DocumentoTipo";
            break;
        case 'CUIT_CLIE':
            campo = "Cuit";
            break;
        case 'FNACIM_CLIE':
            campo = "FechaNacimiento";
            break;
        case 'SEXO_CLIE':
            campo = "Sexo";
            break;
        case 'EDOCIVIL_CLIE':
            campo = "EstadoCivil";
            break;
        case 'NACION_CLIE':
            campo = "Nacionalidad";
            break;
        case 'CONDIVA_CLIE':
            campo = "CategoriaIva";
            break;
        case 'ACTIV_CLIE':
            campo = "Ocupacion";
            break;
    }
    return campo
}

function _validarCampo(valor){
    return ![undefined,null,0,""].some(r=>r==valor)
}

function _existeDireccionPrevia(state){
    let obj={
        repetidoEnPrepaga:false,
        repetidoEnCredito:false,
        existeRegistroPrepaga:false,
        existeRegistroCredito:false,
        repetidoSinCuenta:false
    }
    
    if(state.emailCuentasActuales){
        if(state.checkProductoPrepaga && state.emailCuentasActuales.TP){
            obj.existeRegistroPrepaga = true;
            if(state.emailCuentasActuales.TP.Contacto.toLowerCase() == state.emailEnEdicion.toLowerCase()) obj.repetidoEnPrepaga = true;
            return obj
        }
        if(state.checkProductoCredito && state.emailCuentasActuales.TC){
            obj.existeRegistroCredito = true;
            if(state.emailCuentasActuales.TC.Contacto.toLowerCase() == state.emailEnEdicion.toLowerCase()) obj.repetidoEnCredito = true;
            return obj
        } 
    }
    
    if( state.emailEnEdicion && state.contactosTotal.some(c=> (c.Contacto.toLowerCase() == state.emailEnEdicion.toLowerCase()))){
        obj.repetidoSinCuenta = true;
        
        return obj
    }

    return false
    
}


/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////   FUNCIONES MODIFICACIÓN LOCALIZACIÓN ////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export function guardarMedioLocalizacion(medio, llamadoTrasValidacion,stateValidacion){
    LogHelper.In(guardarMedioLocalizacion.name,medio);
    debugger
    //SE HACE ESTA DIFERENCIACIÓN PORQUE LA FUNCIÓN DE GUARDADO PUEDE ESTAR LLAMANDOSE DESDE EL MODAL DE CONFIRMACIÓN DE REEMPLAZO DE LA FORMA DE COMUNICACIÓN, CON LO QUE DISPATCH Y GETSTATE ESTÁN EN UN SCOPE ANTERIOR
    if(llamadoTrasValidacion){

        _dispatch({ type: LOADING_CLIENTE });
        _guardarMedioLocalizacion(stateValidacion,medio,0)

    }else{
        return (dispatch,getState)=>{
    
            _dispatch = dispatch;
    
            let state = getState();
    
            dispatch({ type: LOADING_CLIENTE });
    
            _guardarMedioLocalizacion(state,medio,0)
        }
    }

}

//FUNCIÓN QUE INTENTA EL GUARDADO EN GLOBAL, SI FALLA LA CANTIDAD DE INTENTOS MÁXIMA, DEFINIDA POR PARAMETRÍA, DISPATCHEA UNA ACTION PARA INFORMAR EL ERROR 
function _guardarMedioLocalizacion(state,medio,intentos){
    
    if(intentos <= state.cliente.reintentosGuardado){
        let paramCuentas = { 
            'numeroCuenta': state.cliente.cuenta.CuentaEntidadNumero,
            'idProducto': state.cliente.cuenta.codigoProducto,
            'body': ""
        }
        let modificacion = state.cliente.modalAbierto.includes("MODIFICACION");
        let desafectarTelefonoPrepaga = false;
        let desafectarCelularPrepaga = false;
        let desafectarMailPrepaga = false;
        let checkPrepagaOn = false;

        switch(medio){

            case "POSTAL":{
                
                let datosCredito ={
                    domicilioViejo : {Legal:null, Correspondencia:null}
                }

                let datosPrepaga ={
                    domicilioViejo : {Legal:null, Correspondencia:null}
                }

                state.cliente.domiciliosTotal.map(d=>{
                    if(d.TipoProducto && d.TipoProducto.includes("de")){
                       if(d.EsDomicilioLegal) datosCredito.domicilioViejo.Legal = d;
                       if(d.EsDomicilioCorrespondencia) datosCredito.domicilioViejo.Correspondencia = d;
                    } 
                    if(d.TipoProducto && d.TipoProducto.includes("Prepaga")){
                        if(d.EsDomicilioLegal) datosPrepaga.domicilioViejo.Legal = d;
                        if(d.EsDomicilioCorrespondencia) datosPrepaga.domicilioViejo.Correspondencia = d;
                    } 
                })

                let codigoProvinciaMaster ="";
                let codigoPaisMaster = "";
                let cPostal="";

                state.cliente.domicilioComponentes.paisRows.map(p=>{if(p.Id == state.cliente.paisId) codigoPaisMaster = p.IdMaster});
                state.cliente.domicilioComponentes.provinciaRows.map(p=>{if(p.Id == state.cliente.provinciaId) codigoProvinciaMaster = p.IdMaster});
                state.cliente.domicilioComponentes.codigoPostalRows.map(p=>{if(p.Id == state.cliente.codigoPostalId) cPostal = p.Descripcion});

                checkPrepagaOn = state.cliente.domicilio.prepagoCheck;
                let checkCreditoOn = state.cliente.domicilio.prepagoCheck;
                let checkLegalPrepagaOn = false;
                let checkCorrespondenciaPrepagaOn = false;

                let calle = state.cliente.calleEdicion;  
                let altura = state.cliente.alturaEdicion;  
                let localidad = state.cliente.localidadEdicion;  
                let codigoPostal = cPostal;  
                let provincia =  codigoProvinciaMaster;  
                let pais =  codigoPaisMaster;  
                let piso = state.cliente.pisoEdicion ? state.cliente.pisoEdicion : '\xa0';  
                let depto = state.cliente.deptoEdicion ? state.cliente.deptoEdicion : '\xa0';  
                let comentarios = state.cliente.comentariosDomicilioEdicion ? state.cliente.comentariosDomicilioEdicion : '\xa0';  

                let objGuardado={calle,altura,localidad,codigoPostal,provincia: state.cliente.provinciaId,pais: state.cliente.paisId,piso,depto,comentarios}
                
                if(checkPrepagaOn){
                    state.cliente.tarjeta_prepaga.map(c=>{
                        if(c.Descripcion=="Legal" && c.Check) checkLegalPrepagaOn = true;
                        if(c.Descripcion=="Correspondencia" && c.Check) checkCorrespondenciaPrepagaOn = true;
                    })

                    
                    if(checkLegalPrepagaOn && !checkCorrespondenciaPrepagaOn){

                        paramCuentas.body = '{"DomicilioParticular" : {'  
                        +'"Calle":"' + calle + '",'
                        +'"Altura":"' + altura + '",'
                        +'"Piso":"' + piso + '",'
                        +'"Departamento":"' + depto + '",'
                        +'"CodigoPostal":"' + codigoPostal + '",'
                        +'"Localidad":"' + localidad + '",'
                        +'"Provincia":"' + provincia + '",'
                        +'"Pais":"' + pais + '",'
                        +'"Comentario":"' + comentarios + '"'
                        +'}}';
                    
                    }else if(!checkLegalPrepagaOn && checkCorrespondenciaPrepagaOn){

                        paramCuentas.body = '{"DomicilioCorrespondencia" : {'  
                        +'"Calle":"' + calle + '",'
                        +'"Altura":"' + altura + '",'
                        +'"Piso":"' + piso + '",'
                        +'"Departamento":"' + depto + '",'
                        +'"CodigoPostal":"' + codigoPostal + '",'
                        +'"Localidad":"' + localidad + '",'
                        +'"Provincia":"' + provincia + '",'
                        +'"Pais":"' + pais + '",'
                        +'"Comentario":"' + comentarios + '"'
                        +'}}';

                    }else if(checkLegalPrepagaOn && checkCorrespondenciaPrepagaOn){

                        paramCuentas.body = '{"DomicilioCorrespondencia" : {'  
                        +'"Calle":"' + calle + '",'
                        +'"Altura":"' + altura + '",'
                        +'"Piso":"' + piso + '",'
                        +'"Departamento":"' + depto + '",'
                        +'"CodigoPostal":"' + codigoPostal + '",'
                        +'"Localidad":"' + localidad + '",'
                        +'"Provincia":"' + provincia + '",'
                        +'"Pais":"' + pais + '",'
                        +'"Comentario":"' + comentarios + '"'
                        +'},'
                        +'"DomicilioParticular" : {'  
                        +'"Calle":"' + calle + '",'
                        +'"Altura":"' + altura + '",'
                        +'"Piso":"' + piso + '",'
                        +'"Departamento":"' + depto + '",'
                        +'"CodigoPostal":"' + codigoPostal + '",'
                        +'"Localidad":"' + localidad + '",'
                        +'"Provincia":"' + provincia + '",'
                        +'"Pais":"' + pais + '",'
                        +'"Comentario":"' + comentarios + '"'
                        +'}}';
                    }

                    if(modificacion && checkPrepagaOn && !checkCorrespondenciaPrepagaOn){
                        if(!state.cliente.domiciliosTotal.some(d=>{d.TipoProducto == "Tarjeta Prepaga" && d.EsDomicilioCorrespondencia})){
                                paramCuentas.body = '{"DomicilioCorrespondencia" : {'  
                            +'"Calle":"' + '\xa0' + '",'
                            +'"Altura":"' + '\xa0' + '",'
                            +'"Piso":"' + '\xa0' + '",'
                            +'"Departamento":"' + '\xa0' + '",'
                            +'"CodigoPostal":"' + '\xa0' + '",'
                            +'"Localidad":"' + '\xa0' + '",'
                            +'"Provincia":"' + '\xa0' + '",'
                            +'"Pais":"' + '\xa0' + '",'
                            +'"Comentario":"' + '\xa0' + '"'
                            +'},'
                            +'"DomicilioParticular" : {'  
                            +'"Calle":"' + calle + '",'
                            +'"Altura":"' + altura + '",'
                            +'"Piso":"' + piso + '",'
                            +'"Departamento":"' + depto + '",'
                            +'"CodigoPostal":"' + codigoPostal + '",'
                            +'"Localidad":"' + localidad + '",'
                            +'"Provincia":"' + provincia + '",'
                            +'"Pais":"' + pais + '",'
                            +'"Comentario":"' + comentarios + '"'
                            +'}}';
                        }
                    }

                }
                
                state.datosGuardado ={
                    TipoComunicacionId:1,
                    nuevoContacto: objGuardado,
                    idNuevoContacto:null,
                    datosCredito,
                    datosPrepaga,
                    datosSinCuenta:{}
                } 
                
                break;
            }
            case "EMAIL":{
                if(modificacion){
                    let medioModif= state.cliente.medioLocalizacionModificacion[0] ? state.cliente.medioLocalizacionModificacion[0] : {};

                    if(medioModif.TipoProducto == "Tarjeta Prepaga"){
                        //SI SE DESTILDA EL TIPO DE PRODUCTO PREPAGA EN LA MODIFICACIÓN O SE CAMBIA EL TIPO DE COMUNICACION DE CELULAR A FIJO O VICEVERSA, CORRESPONDE DESAFECTAR
                        if(!state.cliente.checkProductoPrepaga) desafectarMailPrepaga = true; 
                    }
                }
                
                let datosCredito ={
                    emailViejo: state.cliente.emailCuentasActuales && state.cliente.emailCuentasActuales.TC ? state.cliente.emailCuentasActuales.TC.Contacto : null,
                    emailViejoId: state.cliente.emailCuentasActuales && state.cliente.emailCuentasActuales.TC ? state.cliente.emailCuentasActuales.TC.Id : null
                }

                let datosPrepaga ={
                    emailViejo: state.cliente.emailCuentasActuales && state.cliente.emailCuentasActuales.TP ? state.cliente.emailCuentasActuales.TP.Contacto : null,
                    emailViejoId: state.cliente.emailCuentasActuales && state.cliente.emailCuentasActuales.TP ? state.cliente.emailCuentasActuales.TP.Id : null
                }

                if(!datosPrepaga.emailViejoId){
                    state.cliente.contactosTotal.map(c=>{
                        if(c.TipoProducto== "Tarjeta Prepaga" && ![1,3,4].some(m=>m==c.TipoComunicacionId)){
                            datosPrepaga.emailViejoId = c.Id;
                            datosPrepaga.emailViejo = c.Contacto;
                        }
                    })
                }

                paramCuentas.body = '{'+ '"Email" : ' + '"' + (!desafectarMailPrepaga ? state.cliente.emailEnEdicion : '\xa0') + '"' + '}';
                
                state.datosGuardado ={
                    TipoComunicacionId:state.cliente.tipoDireccionElectronica,
                    nuevoContacto: state.cliente.emailEnEdicion,
                    idNuevoContacto:null,
                    datosCredito,
                    datosPrepaga,
                    datosSinCuenta:{}
                } 
                
                break;
            }

            case "TELEFONO":{
                if(modificacion){
                    let medioModif= state.cliente.medioLocalizacionModificacion[0] ? state.cliente.medioLocalizacionModificacion[0] : {};

                    if(medioModif.TipoProducto == "Tarjeta Prepaga"){
                        //SI SE DESTILDA EL TIPO DE PRODUCTO PREPAGA EN LA MODIFICACIÓN O SE CAMBIA EL TIPO DE COMUNICACION DE CELULAR A FIJO O VICEVERSA, CORRESPONDE DESAFECTAR
                        if(!state.cliente.checkProductoPrepaga && medioModif.TipoComunicacionId == 3 || (medioModif.TipoComunicacionId == 3 && state.cliente.tipoTelefonoEnEdicion == 4)) desafectarCelularPrepaga = true; 
                        if(!state.cliente.checkProductoPrepaga && medioModif.TipoComunicacionId == 4 || (medioModif.TipoComunicacionId == 4 && state.cliente.tipoTelefonoEnEdicion == 3)) desafectarTelefonoPrepaga = true; 
                    }
                }
                                  
                    let datosPrepaga ={
                        celularViejo:"",
                        celularViejoId:null,
                        telfijoViejo:"",
                        telfijoViejoId:null
                    }

                    let datosCredito ={
                        celularViejo:"",
                        celularViejoId:null,
                        telfijoViejo:"",
                        telfijoViejoId:null
                    }
    
                    state.cliente.contactosTotal.map(medio=>{
                        if(medio.TipoProducto){ //SI SON MEDIOS ASOCIADOS A UNA CUENTA
                            //SE AGREGAN LOS DATOS DE LOS CELULARES REGISTRADOS PARA LA CUENTA TIPO CRÉDITO, SE USA ESTA DIFERENCIACIÓN PORQUE EL TIPO DE PRODUCTO VIENE COMO "PREPAGA" O "TARJETA <<<DE>>> CRÉDITO, Y HAY PROBLEMAS CON LOS ACENTOS EN EL SP"
                            if(medio.TipoComunicacionId == 3 && medio.TipoProducto.includes("de")){
                                datosCredito.celularViejo = medio.Contacto;
                                datosCredito.celularViejoId = medio.Id;
                            } 
                            //SE AGREGAN LOS DATOS DE LOS CELULARES REGISTRADOS PARA LA CUENTA TIPO PREPAGA
                            if(medio.TipoComunicacionId == 3 && !medio.TipoProducto.includes("de")){
                                datosPrepaga.celularViejo = medio.Contacto;
                                datosPrepaga.celularViejoId = medio.Id;
                            } 
                            //SE AGREGAN LOS DATOS DE LOS TEL FIJOS REGISTRADOS PARA LA CUENTA TIPO CRÉDITO
                            if(medio.TipoComunicacionId == 4 && medio.TipoProducto.includes("de")){
                                datosCredito.telfijoViejo = medio.Contacto;
                                datosCredito.telfijoViejoId = medio.Id;
                            } 
                            //SE AGREGAN LOS DATOS DE LOS TEL FIJOS REGISTRADOS PARA LA CUENTA TIPO PREPAGA
                            if(medio.TipoComunicacionId == 4 && !medio.TipoProducto.includes("de")){
                                datosPrepaga.telfijoViejo = medio.Contacto;
                                datosPrepaga.telfijoViejoId = medio.Id;
                            } 
                        }
                    })
    
                    paramCuentas.body = '{'
                    + '"Telefonos":{'
                    +  '"Particular":"'+ (!desafectarTelefonoPrepaga ? (state.cliente.tipoTelefonoEnEdicion == 3 ? datosPrepaga.telfijoViejo : state.cliente.telefonoEnEdicion) : "\xa0") + '"'
                    +","
                    +  '"Celular":"'+ (!desafectarCelularPrepaga ? (state.cliente.tipoTelefonoEnEdicion == 3 ? state.cliente.telefonoEnEdicion : datosPrepaga.celularViejo) : "\xa0") + '"'
                    + '}}';
                    
                    state.datosGuardado ={
                        TipoComunicacionId:state.cliente.tipoTelefonoEnEdicion,
                        nuevoContacto: state.cliente.telefonoEnEdicion,
                        idNuevoContacto:null,
                        datosCredito,
                        datosPrepaga,
                        datosSinCuenta:{}
                    } 
                break;

            }

        }
        
        if(state.cliente.checkProductoPrepaga || desafectarTelefonoPrepaga || desafectarCelularPrepaga || desafectarMailPrepaga || checkPrepagaOn){ 
            //SI CHECK PREPAGA ESTÁ TILDADO O SE DESTILDÓ EN UNA MODIFICACIÓN ES NECESARIO INFORMAR EL CAMBIO A GLOBAL
            Engine1Proxy.AddDataSourcesRequests(paramCuentas, 'MODIFICAR_CUENTA', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true, 'modificacionCuenta');
            Engine1Proxy.Execute((data) => _callBackGuardarMedioLocalizacion(data,state,medio,intentos), null, null, "CONSULTASOCIOS");
        }else{
            //CASO CONTRARIO SE PASA DIRECTAMENTE AL GUARDADO EN NUESTRA BASE
            _callBackGuardarMedioLocalizacion({},state,medio,intentos)
        }

    }else{
        //SE AGOTARON TODOS LOS INTENTOS Y SE INFORMA EN LA PANTALLA QUE NO SE PUDO GUARDAR
        _dispatch({ type: INTENTOS_AGOTADOS_GUARDADO_GLOBAL });
        _dispatch({ type: LIMPIAR_EDICIONES });
    }
}

//SI HAY RESPUESTA DE GLOBAL Y NO ES UN ERROR SE LLAMA A LA FUNCIÓN DE GUARDADO EN NUESTRA BASE, CASO CONTRARIO SE VUELVE A LLAMAR A LA FUNCIÓN QUE LE PEGA A GLOBAL
function _callBackGuardarMedioLocalizacion(data,state,medio,intentos){

    //SI NO SE PASÓ POR EL GUARDADO EN GP LA RESPUESTA SE MOCKEA
    var GpRespuesta = data.modificacionCuenta ? JSON.parse(data.modificacionCuenta).Recordset0.Rows[0] : {IsError:false};
    
    if (!GpRespuesta.IsError) {
        
        if(!state.cliente.modalAbierto.includes("MODIFICACION") && !state.cliente.esModificacion){//SI EL MODAL ABIERTO ES EL DE MODIFICACIÓN, EL CIRCUITO DE GUARDADO EN LA BASE ES DISTINTO
            if(medio != "POSTAL"){
                _guardadoEnBase(state,medio)
            }else{
                _guardadoPostalEnBase(state,medio)
            }

        }else{
            if(medio != "POSTAL"){
                _modificarEnBase(state,medio)
            }else{
                _modificarPostalEnBase(state,medio)
            }
        }
        
    }else{
        intentos +=1;
        _guardarMedioLocalizacion(state,medio,intentos)
    }
}

function _guardadoPostalEnBase(state,medio){

    let contacto = state.datosGuardado.nuevoContacto;
    //SE GUARDA EL REGISTRO EN LA TABLA DOMICILIO
    let paramsEventSourcingDomicilio={
        "CLIENTE_ID":state.cliente.id,
        "CALLE":contacto.calle,
        "NUMERO":contacto.altura,
        "PISO":contacto.piso,
        "DEPARTAMENTO":contacto.depto,
        "LOCALIDAD":contacto.localidad,
        "PROVINCIA_ID": parseInt(contacto.provincia),
        "CODIGO_POSTAL":contacto.codigoPostal,
        "FECHA_ALTA": new Date(),
        "FECHA_ULTIMA_MODIFICACION":null,
        "PAIS_ID":parseInt(contacto.pais),
        "ACTIVO":1,
        "COMENTARIO": contacto.comentarios
    }
    
    Engine1Proxy.AddEventSourcingDataRequest(paramsEventSourcingDomicilio, "EVENTSOURCING_TRANSACTION_DOMICILIO", 'Tarjetas', "ADMINEMPCUETAR", null, true, null, false,null);
    Engine1Proxy.Execute((data) => _guardadoPostalEnBaseCallback(data,state,medio), null, null, "CONSULTASOCIOS");

}

function _guardadoPostalEnBaseCallback(data,state,medio){
    _dispatch({ type: LOADING_CLIENTE });
    let domicilioGuardadoId = data.EVENTSOURCING_TRANSACTION_DOMICILIO;
    let contacto = state.datosGuardado.nuevoContacto;
    let cuentaPrepagaId = state.cliente.cuenta.CuentaTarjetaId;
    let cuentaPrepagaDatos = state.datosGuardado.datosPrepaga ? state.datosGuardado.datosPrepaga : null ;
    let cuentaCreditoDatos = state.datosGuardado.datosCredito ? state.datosGuardado.datosCredito : null;

    let datosCheckPrepaga = state.cliente.tarjeta_prepaga;
    let datosCheckCredito = state.cliente.tarjeta_credito;

    let afectaPrepagaLegal;
    let afectaPrepagaCorrespondencia;
    let afectaCreditoLegal;
    let afectaCreditoCorrespondencia;

    datosCheckPrepaga.map(d=>{
        if(d.Descripcion == "Legal" && d.Check) afectaPrepagaLegal = true;
        if(d.Descripcion == "Correspondencia" && d.Check) afectaPrepagaCorrespondencia = true;
    })
    datosCheckCredito.map(d=>{
        if(d.Descripcion == "Legal" && d.Check) afectaCreditoLegal = true;
        if(d.Descripcion == "Correspondencia" && d.Check) afectaCreditoCorrespondencia = true;
    })

    if(afectaPrepagaLegal || afectaPrepagaCorrespondencia){
        //SI SE AFECTÓ EL DOMICILIO LEGAL O CORRESPONDENCIA DE LA CUENTA PREPAGA, HAY QUE VER SI CORRESPONDE INSERTAR UN REGISTRO EN DOMICILIO_LOG PARA LA DESAFECTACIÓN DEL DOMICILIO VIEJO

        if(afectaPrepagaLegal && cuentaPrepagaDatos.domicilioViejo.Legal){
            let domicilioLegalViejo = cuentaPrepagaDatos.domicilioViejo.Legal;

            let paramsDesafectacionLegalLog = {
                "DOMICILIO_ID":domicilioLegalViejo.Id,
                "CLIENTE_ID":state.cliente.id,
                "TIPO_DOMICILIO":null,
                "CALLE":domicilioLegalViejo.Calle,
                "NUMERO":domicilioLegalViejo.Numero,
                "DEPARTAMENTO":domicilioLegalViejo.Departamento,
                "PISO":domicilioLegalViejo.Piso,
                "LOCALIDAD":domicilioLegalViejo.Localidad,
                "PROVINCIA_ID":domicilioLegalViejo.ProvinciaId,
                "CODIGO_POSTAL":domicilioLegalViejo.CodigoPostal,
                "CODIGO_GEOGRAFICO_ID":null,
                "PAIS_ID":domicilioLegalViejo.PaisId,
                "COMENTARIO":domicilioLegalViejo.Comentario,
                "PREPAGA_LEGAL_ID": null,
                "TIPO_OPERACION":"D",
                "FECHA_HORA_OPERACION":new Date(),
                "USUARIO_OPERACION": state.sesion.executionContext.login
            }

            Engine1Proxy.AddEventSourcingDataRequest(paramsDesafectacionLegalLog, "EVENTSOURCING_TRANSACTION_DOMICILIO_LOG", 'Tarjetas', "ADMINEMPCUETAR", null, true, null, false,null);

        }

        if(afectaPrepagaCorrespondencia && cuentaPrepagaDatos.domicilioViejo.Correspondencia){
            let domicilioLegalCorrespondencia = cuentaPrepagaDatos.domicilioViejo.Correspondencia;

            let paramsDesafectacionCorrespondenciaLog = {
                "DOMICILIO_ID":domicilioLegalCorrespondencia.Id,
                "CLIENTE_ID":state.cliente.id,
                "TIPO_DOMICILIO":null,
                "CALLE":domicilioLegalCorrespondencia.Calle,
                "NUMERO":domicilioLegalCorrespondencia.Numero,
                "DEPARTAMENTO":domicilioLegalCorrespondencia.Departamento,
                "PISO":domicilioLegalCorrespondencia.Piso,
                "LOCALIDAD":domicilioLegalCorrespondencia.Localidad,
                "PROVINCIA_ID":domicilioLegalCorrespondencia.ProvinciaId,
                "CODIGO_POSTAL":domicilioLegalCorrespondencia.CodigoPostal,
                "CODIGO_GEOGRAFICO_ID":null,
                "PAIS_ID":domicilioLegalCorrespondencia.PaisId,
                "COMENTARIO":domicilioLegalCorrespondencia.Comentario,
                "PREPAGA_LEGAL_ID": null,
                "TIPO_OPERACION":"D",
                "FECHA_HORA_OPERACION":new Date(),
                "USUARIO_OPERACION": state.sesion.executionContext.login
            }

            Engine1Proxy.AddEventSourcingDataRequest(paramsDesafectacionCorrespondenciaLog, "EVENTSOURCING_TRANSACTION_DOMICILIO_LOG", 'Tarjetas', "ADMINEMPCUETAR", null, true, null, false,null);

        }
        
        //SE INSERTA UN REGISTRO EN EL LOG CON EL ALTA DEL DOMICILIO CREADO
        let paramsDomicilioLogInsert = {
            "DOMICILIO_ID":domicilioGuardadoId,
            "CLIENTE_ID":state.cliente.id,
            "TIPO_DOMICILIO":null,
            "CALLE":contacto.calle,
            "NUMERO":contacto.altura,
            "DEPARTAMENTO":contacto.depto,
            "PISO":contacto.piso,
            "LOCALIDAD":contacto.localidad,
            "PROVINCIA_ID":parseInt(contacto.provincia),
            "CODIGO_POSTAL":contacto.codigoPostal,
            "CODIGO_GEOGRAFICO_ID":null,
            "PAIS_ID":parseInt(contacto.pais),
            "COMENTARIO":contacto.comentarios,
            "PREPAGA_LEGAL_ID": afectaPrepagaLegal ? cuentaPrepagaId : null,
            "PREPAGA_CORRESP_ID": afectaPrepagaCorrespondencia ? cuentaPrepagaId : null,
            "TIPO_OPERACION":"A",
            "FECHA_HORA_OPERACION":new Date(),
            "USUARIO_OPERACION": state.sesion.executionContext.login
        }

        //SE REALIZA LA MODIFICACIÓN DEL REGISTRO EN CUENTA_TARJETA PARA EL CAMPO QUE CORRESPONDA (LEGAL O CORRESPONDENCIA)
        let paramsModifCuentaTarjeta = {};

        if(afectaPrepagaLegal) paramsModifCuentaTarjeta.DOMICILIO_PARTICULAR_ID = domicilioGuardadoId;
        if(afectaPrepagaCorrespondencia) paramsModifCuentaTarjeta.DOMICILIO_CORRESPONDENCIA_ID = domicilioGuardadoId;
         
        
        Engine1Proxy.AddEventSourcingDataRequest(paramsModifCuentaTarjeta, "EVENTSOURCING_TRANSACTION_CUENTA_TARJETA", 'Tarjetas', "ADMINEMPCUETAR", null, true, null, false,cuentaPrepagaId);
        Engine1Proxy.AddEventSourcingDataRequest(paramsDomicilioLogInsert, "EVENTSOURCING_TRANSACTION_DOMICILIO_LOG", 'Tarjetas', "ADMINEMPCUETAR", null, true, null, false,null);
        Engine1Proxy.Execute((data) => _actualizarDomiciliosCliente(state.cliente.id), null, null, "CONSULTASOCIOS");
        
    }else{
        _actualizarDomiciliosCliente(state.cliente.id)
    }
    //EN CUALQUIERA DE LOS DOS CASOS, SEA QUE HAY AFECTACIONES A CUENTAS O NO, SE ACTUALIZAN LOS DOMICILIOS PARA REFRESCAR LA VISTA
}

function _actualizarDomiciliosCliente(clienteId){
    let paramDom = {"CLIENTE_ID": clienteId};

    Engine1Proxy.AddDataSourcesRequests(paramDom, 'GET_DOMICILIOS_BY_CLIENTE_ID', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true);

    Engine1Proxy.Execute((data)=>_callBackActualizarDomiciliosCliente(data), null, null, "CONSULTASOCIOS");
}

function _callBackActualizarDomiciliosCliente(data){
    let domAux = JSON.parse(data.GET_DOMICILIOS_BY_CLIENTE_ID);
    let infoDomiciliosCuenta = domAux.Recordset1.Rows;
    let domiciliosTotal = ContactoHelper.DomicilioHelper(domAux.Recordset0.Rows, domAux.Recordset1.Rows);
    domiciliosTotal.map(d=>d.MedioNombre= "POSTAL");

    _dispatch({ type: GET_SCREEN_DATA_DOMICILIO, domicilios: domiciliosTotal, infoDomiciliosCuenta });
    _dispatch({ type: LIMPIAR_EDICIONES });
}

function _guardadoEnBase(state,medio){
    debugger;
    let paramFC = {};
    let paramDom = {"CLIENTE_ID": state.cliente.id};

    if(state.cliente.checkProductoPrepaga){
        paramFC = {
            "TIPO_COMUNICACION_ID":state.datosGuardado.TipoComunicacionId,
            "CUENTA_TARJETA_ID":state.cliente.cuenta.CuentaTarjetaId,
            "CONTACTO":state.datosGuardado.nuevoContacto,
            "CLIENTE_ID":state.cliente.id
        }
        Engine1Proxy.AddEventSourcingDataRequest(paramFC, "EVENTSOURCING_TRANSACTION_FORMA_COMUNICACION", 'Tarjetas', "ADMINEMPCUETAR", null, true, null,false, null);  
    }

    if(state.cliente.checkProductoCredito){
        paramFC = {
            "TIPO_COMUNICACION_ID":state.datosGuardado.TipoComunicacionId,
            "CUENTA_TARJETA_ID":state.cliente.cuentaCredito.CuentaTarjetaId,
            "CONTACTO":state.datosGuardado.nuevoContacto,
            "CLIENTE_ID":state.cliente.id
        }
        Engine1Proxy.AddEventSourcingDataRequest(paramFC, "EVENTSOURCING_TRANSACTION_FORMA_COMUNICACION", 'Tarjetas', "ADMINEMPCUETAR", null, true, null,false, null);  
    }

    if(!state.cliente.checkProductoCredito && !state.cliente.checkProductoPrepaga){
        paramFC = {
            "TIPO_COMUNICACION_ID":state.datosGuardado.TipoComunicacionId,
            "CUENTA_TARJETA_ID": null,
            "CONTACTO":state.datosGuardado.nuevoContacto,
            "CLIENTE_ID":state.cliente.id
        }
       Engine1Proxy.AddEventSourcingDataRequest(paramFC, "EVENTSOURCING_TRANSACTION_FORMA_COMUNICACION", 'Tarjetas', "ADMINEMPCUETAR", null, true, null,false, null);  
    }
    Engine1Proxy.AddDataSourcesRequests(paramDom, 'GET_CONTACTO_BY_ID_CLIENTE', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'Product', true);
    Engine1Proxy.Execute((data) => _guardadoEnBaseCallback(data,state,medio), null, null, "CONSULTASOCIOS");  
}

function _guardadoEnBaseCallback(data,state,medio){
    let contacto = JSON.parse(data.GET_CONTACTO_BY_ID_CLIENTE).Recordset0.Rows;

    //SE OBTIENEN LOS REGISTROS CREADOS PARA LA CUENTA PREPAGA Y CREDITO, PARA INSERTAR EL REGISTRO DE ALTA EN EL LOG
    let registroNuevoPrepaga = contacto.reduce((acum,currentValue)=>{
        if(currentValue.Id > acum.Id && currentValue.TipoProducto.includes("Prepaga")){ 
            return currentValue
        }else{
            return acum
        }},{Id:0});

    let registroNuevoCredito = contacto.reduce((acum,currentValue)=>{
        if(currentValue.Id > acum.Id && currentValue.TipoProducto.includes("de")){
             return currentValue
            }else{
            return acum
        }},{Id:0});
    
    
    let registroP;
    let registroC;
    let registroSinCuenta;

    registroP = registroNuevoPrepaga.Id != 0 ? registroNuevoPrepaga.Id : null ;
    registroC = registroNuevoCredito.Id != 0  ? registroNuevoCredito.Id : null ;
    
    
    //OBTENCIÓN DEL REGISTRO GUARDADO EN FORMA_COMUNICACIÓN PARA LA CUENTA PREPAGA Y LA CUENTA CRÉDITO SI ES QUE HAY
    if(state.cliente.checkProductoPrepaga && state.cliente.checkProductoCredito ){
        state.datosGuardado.datosPrepaga.idNuevoContacto = registroP;
        state.datosGuardado.datosCredito.idNuevoContacto = registroC;
    }else{
        if(state.cliente.checkProductoPrepaga){
            state.datosGuardado.datosPrepaga.idNuevoContacto = registroP;
        }
        if(state.cliente.checkProductoCredito){
            state.datosGuardado.datosCredito.idNuevoContacto = registroC;
        }
        if(!state.cliente.checkProductoCredito && !state.cliente.checkProductoPrepaga){
            registroSinCuenta = data.EVENTSOURCING_TRANSACTION_FORMA_COMUNICACION;
            state.datosGuardado.datosSinCuenta.idNuevoContacto = registroSinCuenta;
        }
    }

    let usuario = state.sesion.executionContext.login;
    let isQuery = false;
    let deleteInstance = false;
    let hayQueDesafectarPrepaga = false; //FLAG PARA NULLEAR EL CAMPO CuentaTarjetaId en la forma de comunicación que se reemplaza e insertar este blanqueo en el log
    let hayQueDesafectarCredito = false; 
    
    let objetoDesafectacionPrepaga = { 
        formaComunicacionAnteriorId:null,
        contactoAnterior:null
    }
    let objetoDesafectacionCredito = { 
        formaComunicacionAnteriorId:null,
        contactoAnterior:null
    }
    
    switch(medio){
        case "EMAIL":{
            hayQueDesafectarPrepaga = (state.cliente.checkProductoPrepaga  && _validarCampo(state.datosGuardado.datosPrepaga.emailViejo))
            hayQueDesafectarCredito = (state.cliente.checkProductoCredito && _validarCampo(state.datosGuardado.datosCredito.emailViejo))

            if(hayQueDesafectarPrepaga){
                objetoDesafectacionPrepaga = { 
                    formaComunicacionAnteriorId: state.datosGuardado.datosPrepaga.emailViejoId,
                    contactoAnterior:  state.datosGuardado.datosPrepaga.emailViejo
                }
            }

            if(hayQueDesafectarCredito){
                objetoDesafectacionCredito = { 
                    formaComunicacionAnteriorId: state.datosGuardado.datosCredito.emailViejoId,
                    contactoAnterior:  state.datosGuardado.datosCredito.emailViejo
                }
            }
            break;
        }
        case "TELEFONO":{
            hayQueDesafectarPrepaga = (state.cliente.checkProductoPrepaga  &&  ((state.datosGuardado.TipoComunicacionId == 3 && state.datosGuardado.datosPrepaga.celularViejo != "") || (state.datosGuardado.TipoComunicacionId == 4 && state.datosGuardado.datosPrepaga.telfijoViejo != "")))
            hayQueDesafectarCredito = (state.cliente.checkProductoCredito && ((state.datosGuardado.TipoComunicacionId == 3 && state.datosGuardado.datosCredito.celularViejo != "") || (state.datosGuardado.TipoComunicacionId == 4 && state.datosGuardado.datosCredito.telfijoViejo != "")))
            
            if(hayQueDesafectarPrepaga){
                objetoDesafectacionPrepaga = { 
                    formaComunicacionAnteriorId: state.datosGuardado.TipoComunicacionId == 3 ? state.datosGuardado.datosPrepaga.celularViejoId : state.datosGuardado.datosPrepaga.telfijoViejoId,
                    contactoAnterior:  state.datosGuardado.TipoComunicacionId == 3 ? state.datosGuardado.datosPrepaga.celularViejo : state.datosGuardado.datosPrepaga.telfijoViejo
                }
            }

            if(hayQueDesafectarCredito){
                objetoDesafectacionCredito = { 
                    formaComunicacionAnteriorId: state.datosGuardado.TipoComunicacionId == 3 ? state.datosGuardado.datosCredito.celularViejoId : state.datosGuardado.datosCredito.telfijoViejoId,
                    contactoAnterior:  state.datosGuardado.TipoComunicacionId == 3 ? state.datosGuardado.datosCredito.celularViejo : state.datosGuardado.datosCredito.telfijoViejo
                }
            }
            
            break;
        }
    }
    
    //PARÁMETROS EVENTSOURCING PARA DESAFECTACIÓN DE LA FORMA DE COMUNICACIÓN ANTERIOR
    let localValues = {
        "CUENTA_TARJETA_ID": null
    }
      
    //PARÁMETROS INSERT TABLA LOG DE LA DESAFECTACIÓN DE LA FORMA DE COMUNICACIÓN ANTERIOR (PREPAGA)
    let paramDesafectacionPrepaga = {
        'FORMA_COMUNICACION_ID': objetoDesafectacionPrepaga.formaComunicacionAnteriorId,
        'TIPO_COMUNICACION_ID': state.datosGuardado.TipoComunicacionId,
        'CUENTA_TARJETA_ID': state.cliente.cuenta.CuentaTarjetaId,
        'CLIENTE_ID': state.cliente.id,
        'CONTACTO': objetoDesafectacionPrepaga.contactoAnterior,
        'TIPO_OPERACION': "D",
        'USUARIO_OPERACION': usuario,
        "FECHA_OPERACION": new Date()
    }  

    //PARÁMETROS INSERT TABLA LOG DE LA FORMA DE COMUNICACIÓN NUEVA (PREPAGA)
    let paramNuevoPrepaga = {
        'FORMA_COMUNICACION_ID': state.datosGuardado.datosPrepaga.idNuevoContacto,
        'TIPO_COMUNICACION_ID': state.datosGuardado.TipoComunicacionId, 
        'CUENTA_TARJETA_ID': state.cliente.cuenta.CuentaTarjetaId,
        'CLIENTE_ID': state.cliente.id,
        'CONTACTO': state.datosGuardado.nuevoContacto,
        'TIPO_OPERACION': "A",
        'USUARIO_OPERACION': usuario,
        "FECHA_OPERACION": new Date()
    }  

    //PARÁMETROS INSERT TABLA LOG DE LA DESAFECTACIÓN DE LA FORMA DE COMUNICACIÓN ANTERIOR (CRÉDITO)
    let paramDesafectacionCredito = {
        'FORMA_COMUNICACION_ID': objetoDesafectacionCredito.formaComunicacionAnteriorId,
        'TIPO_COMUNICACION_ID': state.datosGuardado.TipoComunicacionId,
        'CUENTA_TARJETA_ID': state.cliente.cuentaCredito ? state.cliente.cuentaCredito.CuentaTarjetaId : null,
        'CLIENTE_ID': state.cliente.id,
        'CONTACTO': objetoDesafectacionCredito.contactoAnterior,
        'TIPO_OPERACION': "D",
        'USUARIO_OPERACION': usuario,
        "FECHA_OPERACION": new Date()
    }  

    //PARÁMETROS INSERT TABLA LOG DE LA FORMA DE COMUNICACIÓN NUEVA (CRÉDITO)
    let paramNuevoCredito= {
        'FORMA_COMUNICACION_ID': state.datosGuardado.datosCredito.idNuevoContacto,
        'TIPO_COMUNICACION_ID': state.datosGuardado.TipoComunicacionId, 
        'CUENTA_TARJETA_ID':  state.cliente.cuentaCredito ? state.cliente.cuentaCredito.CuentaTarjetaId : null,
        'CLIENTE_ID': state.cliente.id,
        'CONTACTO': state.datosGuardado.nuevoContacto,
        'TIPO_OPERACION': "A",
        'USUARIO_OPERACION': usuario,
        "FECHA_OPERACION": new Date()
    }

    //PARÁMETROS INSERT TABLA LOG DE LA FORMA DE COMUNICACIÓN NUEVA SIN CUENTA ASOCIADA
    let paramNuevoSinCuenta= {
        'FORMA_COMUNICACION_ID': state.datosGuardado.datosSinCuenta ? state.datosGuardado.datosSinCuenta.idNuevoContacto : null,
        'TIPO_COMUNICACION_ID': state.datosGuardado.TipoComunicacionId, 
        'CUENTA_TARJETA_ID': null,
        'CLIENTE_ID': state.cliente.id,
        'CONTACTO': state.datosGuardado.nuevoContacto,
        'TIPO_OPERACION': "A",
        'USUARIO_OPERACION': usuario,
        "FECHA_OPERACION": new Date()
    }  
    
    if(hayQueDesafectarPrepaga){
        Engine1Proxy.AddEventSourcingDataRequest(paramDesafectacionPrepaga, "EVENTSOURCING_TRANSACTION_FORMA_COMUNICACION_LOG", 'Tarjetas', "ADMINEMPCUETAR", null, true, null,false, null);
        Engine1Proxy.AddEventSourcingDataRequest(localValues, "EVENTSOURCING_TRANSACTION_FORMA_COMUNICACION", 'Tarjetas', "ADMINEMPCUETAR", null, isQuery, null, deleteInstance,objetoDesafectacionPrepaga.formaComunicacionAnteriorId);
    }

    if(hayQueDesafectarCredito){
        Engine1Proxy.AddEventSourcingDataRequest(paramDesafectacionCredito, "EVENTSOURCING_TRANSACTION_FORMA_COMUNICACION_LOG", 'Tarjetas', "ADMINEMPCUETAR", null, true, null,false, null);
        Engine1Proxy.AddEventSourcingDataRequest(localValues, "EVENTSOURCING_TRANSACTION_FORMA_COMUNICACION", 'Tarjetas', "ADMINEMPCUETAR", null, isQuery, null, deleteInstance, objetoDesafectacionCredito.formaComunicacionAnteriorId);
    }

    if(state.cliente.checkProductoPrepaga){
        Engine1Proxy.AddEventSourcingDataRequest(paramNuevoPrepaga, "EVENTSOURCING_TRANSACTION_FORMA_COMUNICACION_LOG", 'Tarjetas', "ADMINEMPCUETAR", null, true, null,false, null);
    }

    if(state.cliente.checkProductoCredito){
        Engine1Proxy.AddEventSourcingDataRequest(paramNuevoCredito, "EVENTSOURCING_TRANSACTION_FORMA_COMUNICACION_LOG", 'Tarjetas', "ADMINEMPCUETAR", null, true, null,false, null);
    }

    if(!state.cliente.checkProductoPrepaga && !state.cliente.checkProductoCredito){
        Engine1Proxy.AddEventSourcingDataRequest(paramNuevoSinCuenta, "EVENTSOURCING_TRANSACTION_FORMA_COMUNICACION_LOG", 'Tarjetas', "ADMINEMPCUETAR", null, true, null,false, null);
    }
    
    Engine1Proxy.Execute(()=>_actualizarLocalizacionCliente(state.cliente.id, true), null, null, "ADMINEMPCUETAR");
}

//FUNCIÓN QUE CORRE EN VEZ DE _guardarEnBase CUANDO SE TRATA DE UNA MODIFICACIÓN
function _modificarEnBase(state,medio){
    let usuario = state.sesion.executionContext.login;
    let isQuery = false;
    let deleteInstance = false;
    let cuentaPrepaga = state.cliente.cuenta;
    let cuentaCredito = state.cliente.cuentaCredito ? state.cliente.cuentaCredito : {};
    let {datosGuardado} = state;
    let medioModificado = state.cliente.medioLocalizacionModificacion[0];
    let tipoModificacion = {
        cambiaTipo:false,
        cambiaContacto:false,
        eliminaProducto:false
    };
    datosGuardado.tipoModificacion = tipoModificacion;
    
    switch (medio){
        case "TELEFONO":{
            let desafectarTelefonoPrepaga = false;
            let desafectarTelefonoCredito = false;
            let desafectarCelularPrepaga = false;
            let desafectarCelularCredito = false;
            let asociacionProducto=null;
            let desafectaPorCambioTipoPrepaga =false;
            if(state.cliente.checkProductoCredito) asociacionProducto = cuentaCredito.CuentaTarjetaId;
            if(state.cliente.checkProductoPrepaga) asociacionProducto = cuentaPrepaga.CuentaTarjetaId;

            if(medioModificado.TipoComunicacionId != state.cliente.tipoTelefonoEnEdicion) tipoModificacion.cambiaTipo = true;
            if(medioModificado.Contacto != state.cliente.telefonoEnEdicion) tipoModificacion.cambiaContacto = true;

            if(!medioModificado.TipoProducto){//SI SE ESTÁ MODIFICANDO UN MEDIO QUE NO ESTABA ASOCIADO A CUENTAS Y AHORA SE TILDÓ ALGÚN TIPO DE CUENTA, HAY QUE BLANQUEAR EL MEDIO QUE TENÍA ASOCIADO LA MISMA
                if(datosGuardado.TipoComunicacionId == 3){
                    if(state.cliente.checkProductoPrepaga && datosGuardado.datosPrepaga.celularViejoId) desafectarCelularPrepaga = true;
                    if(state.cliente.checkProductoCredito && datosGuardado.datosCredito.celularViejoId) desafectarCelularCredito = true;
                }
                if(datosGuardado.TipoComunicacionId == 4){
                    if(state.cliente.checkProductoPrepaga && datosGuardado.datosPrepaga.telfijoViejoId) desafectarTelefonoPrepaga = true;
                    if(state.cliente.checkProductoCredito && datosGuardado.datosCredito.telfijoViejoId) desafectarTelefonoCredito = true;
                }
            }
            
            if(medioModificado.TipoProducto && medioModificado.TipoProducto.includes("Prepaga")){//SE SE MODIFICA UN MEDIO QUE ESTABA ASOCIADO A UN TIPO DE CUENTA PREPAGA Y AHORA YA NO LO ESTÁ, HAY QUE DESAFECTAR
                if(medioModificado.TipoComunicacionId == 3){
                    if(!state.cliente.checkProductoPrepaga) desafectarCelularPrepaga = true;
                    //SI EN UNA MODIFICACIÓN SE CAMBIA EL TIPO DE TELÉFONO HAY QUE DESAFECTAR EL QUE LA CUENTA TENÍA ASOCIADO PARA ESE TIPO
                    if(state.cliente.checkProductoPrepaga && state.cliente.tipoTelefonoEnEdicion == 4 && datosGuardado.datosPrepaga.telfijoViejoId) desafectaPorCambioTipoPrepaga  = true;
                }
                if(medioModificado.TipoComunicacionId == 4){
                    if(!state.cliente.checkProductoPrepaga) desafectarTelefonoPrepaga = true;
                    //SI EN UNA MODIFICACIÓN SE CAMBIA EL TIPO DE TELÉFONO HAY QUE DESAFECTAR EL QUE LA CUENTA TENÍA ASOCIADO PARA ESE TIPO
                    if(state.cliente.checkProductoPrepaga && state.cliente.tipoTelefonoEnEdicion == 3 && datosGuardado.datosPrepaga.celularViejoId) desafectaPorCambioTipoPrepaga  = true;
                }
            }

            if(medioModificado.TipoProducto && medioModificado.TipoProducto.includes("de")){//SE SE MODIFICA UN MEDIO QUE ESTABA ASOCIADO A UN TIPO DE CUENTA CRÉDITO Y AHORA YA NO LO ESTÁ, HAY QUE DESAFECTAR
                if(medioModificado.TipoComunicacionId == 3){
                    if(!state.cliente.checkProductoCredito) desafectarCelularCredito = true;
                }
                if(medioModificado.TipoComunicacionId == 4){
                    if(!state.cliente.checkProductoCredito) desafectarTelefonoCredito = true;
                }
            }
                    
            
            //PARÁMETROS PARA EL EVENTSOURCING QUE MODIFICA EL REGISTRO EN FORMA_COMUNICACION
            let paramsCambioTipo ={
                'TIPO_COMUNICACION_ID': state.cliente.tipoTelefonoEnEdicion,
                'CONTACTO': state.cliente.telefonoEnEdicion,
                'CUENTA_TARJETA_ID': asociacionProducto,
                'CLIENTE_ID': state.cliente.id
            }

            //PARÁMETROS INSERT TABLA LOG DE LA FORMA DE COMUNICACIÓN MODIFICADA PARA LA CUENTA PREPAGA 
            let paramsModificacionLogPrepaga = {
                'FORMA_COMUNICACION_ID': medioModificado.Id,
                'TIPO_COMUNICACION_ID': datosGuardado.TipoComunicacionId, 
                'CUENTA_TARJETA_ID': cuentaPrepaga.CuentaTarjetaId,
                'CLIENTE_ID': state.cliente.id,
                'CONTACTO': state.cliente.telefonoEnEdicion,
                'TIPO_OPERACION': "M",
                'USUARIO_OPERACION': usuario,
                'FECHA_OPERACION': new Date()
            }

            //PARÁMETROS INSERT TABLA LOG DE LA FORMA DE COMUNICACIÓN MODIFICADA PARA LA CUENTA CREDITO
            let paramsModificacionLogCredito = {
                'FORMA_COMUNICACION_ID': medioModificado.Id,
                'TIPO_COMUNICACION_ID': medioModificado.TipoComunicacionId, 
                'CUENTA_TARJETA_ID': cuentaCredito.CuentaTarjetaId,
                'CLIENTE_ID': state.cliente.id,
                'CONTACTO': state.cliente.telefonoEnEdicion,
                'TIPO_OPERACION': "M",
                'USUARIO_OPERACION': usuario,
                'FECHA_OPERACION': new Date()
            }

            //PARÁMETROS INSERT TABLA LOG DE LA FORMA DE COMUNICACIÓN MODIFICADA SIN CUENTA ASOCIADA
            let paramsInsertModifLogSinCta = {
                'FORMA_COMUNICACION_ID':  medioModificado.Id,
                'TIPO_COMUNICACION_ID': state.cliente.tipoTelefonoEnEdicion, 
                'CUENTA_TARJETA_ID': asociacionProducto,
                'CLIENTE_ID': state.cliente.id,
                'CONTACTO': state.cliente.telefonoEnEdicion,
                'TIPO_OPERACION': "M",
                'USUARIO_OPERACION': usuario,
                'FECHA_OPERACION': new Date()
            }
            
            //PARÁMETROS PARA EL EVENTSOURCING QUE NULLEA CUENTA_TARJETA EN EL REGISTRO EN FORMA_COMUNICACION SI CORRESPONDE
            let paramsBlanqueoMedio ={
                'CUENTA_TARJETA_ID': null
            }

            //PARÁMETROS INSERT TABLA LOG DE LA FORMA DE COMUNICACIÓN DESAFECTADA PARA LA CUENTA PREPAGA SI CORRESPONDE
            let paramsBlanqueoPrepaga = {
                'FORMA_COMUNICACION_ID':  null,
                'TIPO_COMUNICACION_ID': null, 
                'CUENTA_TARJETA_ID': cuentaPrepaga && cuentaPrepaga.CuentaTarjetaId,
                'CLIENTE_ID': state.cliente.id,
                'CONTACTO': null,
                'TIPO_OPERACION': "X",
                'USUARIO_OPERACION': usuario,
                'FECHA_OPERACION': new Date()
            }

            //PARÁMETROS INSERT TABLA LOG DE LA FORMA DE COMUNICACIÓN DESAFECTADA PARA LA CUENTA CREDITO SI CORRESPONDE
            let paramsBlanqueoCredito = {
                'FORMA_COMUNICACION_ID':  null,
                'TIPO_COMUNICACION_ID': null, 
                'CUENTA_TARJETA_ID': cuentaCredito && cuentaCredito.CuentaTarjetaId,
                'CLIENTE_ID': state.cliente.id,
                'CONTACTO': null,
                'TIPO_OPERACION': "X",
                'USUARIO_OPERACION': usuario,
                'FECHA_OPERACION': new Date()
            }

            if(desafectarTelefonoPrepaga){
                paramsBlanqueoPrepaga.FORMA_COMUNICACION_ID = datosGuardado.datosPrepaga.telfijoViejoId;
                paramsBlanqueoPrepaga.TIPO_COMUNICACION_ID = 4;
                paramsBlanqueoPrepaga.CONTACTO = datosGuardado.datosPrepaga.telfijoViejo;

                //Engine1Proxy.AddDataSourcesRequests(paramsBlanqueoPrepaga, 'UP_INSERTAR_FORMA_COMUNICACION_LOG', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true, 'InsertFormaComunicacionLogModificacion');
                Engine1Proxy.AddEventSourcingDataRequest(paramsBlanqueoPrepaga, "EVENTSOURCING_TRANSACTION_FORMA_COMUNICACION_LOG", 'Tarjetas', "ADMINEMPCUETAR", null, true, null,false, null);
                Engine1Proxy.AddEventSourcingDataRequest(paramsBlanqueoMedio, "EVENTSOURCING_TRANSACTION_FORMA_COMUNICACION", 'Tarjetas', "ADMINEMPCUETAR", null, isQuery, null, deleteInstance,  datosGuardado.datosPrepaga.telfijoViejoId);

            }

            if(desafectarCelularPrepaga){
                paramsBlanqueoPrepaga.FORMA_COMUNICACION_ID = datosGuardado.datosPrepaga.celularViejoId;
                paramsBlanqueoPrepaga.TIPO_COMUNICACION_ID = 3;
                paramsBlanqueoPrepaga.CONTACTO = datosGuardado.datosPrepaga.celularViejo;

                //Engine1Proxy.AddDataSourcesRequests(paramsBlanqueoPrepaga, 'UP_INSERTAR_FORMA_COMUNICACION_LOG', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true, 'InsertFormaComunicacionLogModificacion');
                Engine1Proxy.AddEventSourcingDataRequest(paramsBlanqueoPrepaga, "EVENTSOURCING_TRANSACTION_FORMA_COMUNICACION_LOG", 'Tarjetas', "ADMINEMPCUETAR", null, true, null,false, null);
                Engine1Proxy.AddEventSourcingDataRequest(paramsBlanqueoMedio, "EVENTSOURCING_TRANSACTION_FORMA_COMUNICACION", 'Tarjetas', "ADMINEMPCUETAR", null, isQuery, null, deleteInstance,  datosGuardado.datosPrepaga.celularViejoId);

            }

            if(desafectarTelefonoCredito ){
                paramsBlanqueoPrepaga.FORMA_COMUNICACION_ID = datosGuardado.datosCredito.telfijoViejoId;
                paramsBlanqueoPrepaga.TIPO_COMUNICACION_ID = 4;
                paramsBlanqueoPrepaga.CONTACTO = datosGuardado.datosCredito.telfijoViejo;

                //Engine1Proxy.AddDataSourcesRequests(paramsBlanqueoPrepaga, 'UP_INSERTAR_FORMA_COMUNICACION_LOG', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true, 'InsertFormaComunicacionLogModificacion');
                Engine1Proxy.AddEventSourcingDataRequest(paramsBlanqueoPrepaga, "EVENTSOURCING_TRANSACTION_FORMA_COMUNICACION_LOG", 'Tarjetas', "ADMINEMPCUETAR", null, true, null,false, null);
                Engine1Proxy.AddEventSourcingDataRequest(paramsBlanqueoMedio, "EVENTSOURCING_TRANSACTION_FORMA_COMUNICACION", 'Tarjetas', "ADMINEMPCUETAR", null, isQuery, null, deleteInstance,  datosGuardado.datosCredito.telfijoViejoId);
            }

            if(desafectarCelularCredito){
                paramsBlanqueoPrepaga.FORMA_COMUNICACION_ID = datosGuardado.datosCredito.celularViejoId;
                paramsBlanqueoPrepaga.TIPO_COMUNICACION_ID = 3;
                paramsBlanqueoPrepaga.CONTACTO = datosGuardado.datosCredito.celularViejo;

                //Engine1Proxy.AddDataSourcesRequests(paramsBlanqueoPrepaga, 'UP_INSERTAR_FORMA_COMUNICACION_LOG', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true, 'InsertFormaComunicacionLogModificacion');
                Engine1Proxy.AddEventSourcingDataRequest(paramsBlanqueoPrepaga, "EVENTSOURCING_TRANSACTION_FORMA_COMUNICACION_LOG", 'Tarjetas', "ADMINEMPCUETAR", null, true, null,false, null);
                Engine1Proxy.AddEventSourcingDataRequest(paramsBlanqueoMedio, "EVENTSOURCING_TRANSACTION_FORMA_COMUNICACION", 'Tarjetas', "ADMINEMPCUETAR", null, isQuery, null, deleteInstance,  datosGuardado.datosCredito.celularViejoId);

            }

            if(desafectaPorCambioTipoPrepaga){

                let paramsDesafectacionPorModifTipo = {
                    'FORMA_COMUNICACION_ID':  state.cliente.tipoTelefonoEnEdicion == 3 ? datosGuardado.datosPrepaga.celularViejoId : datosGuardado.datosPrepaga.telfijoViejoId,
                    'TIPO_COMUNICACION_ID': state.cliente.tipoTelefonoEnEdicion == 3 ? 4 : 3, 
                    'CUENTA_TARJETA_ID': cuentaPrepaga.CuentaTarjetaId,
                    'CLIENTE_ID': state.cliente.id,
                    'CONTACTO':  state.cliente.tipoTelefonoEnEdicion == 3 ? datosGuardado.datosPrepaga.celularViejo : datosGuardado.datosPrepaga.telfijoViejo,
                    'TIPO_OPERACION': "X",
                    'USUARIO_OPERACION': usuario,
                    'FECHA_OPERACION': new Date()
                }

                //Engine1Proxy.AddDataSourcesRequests(paramsDesafectacionPorModifTipo, 'UP_INSERTAR_FORMA_COMUNICACION_LOG', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true, 'InsertFormaComunicacionLogModificacionC');
                Engine1Proxy.AddEventSourcingDataRequest(paramsDesafectacionPorModifTipo, "EVENTSOURCING_TRANSACTION_FORMA_COMUNICACION_LOG", 'Tarjetas', "ADMINEMPCUETAR", null, true, null,false, null);
                Engine1Proxy.AddEventSourcingDataRequest(paramsBlanqueoMedio, "EVENTSOURCING_TRANSACTION_FORMA_COMUNICACION", 'Tarjetas', "ADMINEMPCUETAR", null, isQuery, null, deleteInstance, state.cliente.tipoTelefonoEnEdicion == 3 ? datosGuardado.datosPrepaga.celularViejoId : datosGuardado.datosPrepaga.telfijoViejoId );
            }


            if(state.cliente.checkProductoPrepaga){
                //Engine1Proxy.AddDataSourcesRequests(paramsModificacionLogPrepaga, 'UP_INSERTAR_FORMA_COMUNICACION_LOG', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true, 'InsertFormaComunicacionLogModificacion');
                Engine1Proxy.AddEventSourcingDataRequest(paramsModificacionLogPrepaga, "EVENTSOURCING_TRANSACTION_FORMA_COMUNICACION_LOG", 'Tarjetas', "ADMINEMPCUETAR", null, true, null,false, null);
                Engine1Proxy.AddEventSourcingDataRequest(paramsCambioTipo, "EVENTSOURCING_TRANSACTION_FORMA_COMUNICACION", 'Tarjetas', "ADMINEMPCUETAR", null, isQuery, null, deleteInstance, medioModificado.Id);
            }

            if(state.cliente.checkProductoCredito){
                //Engine1Proxy.AddDataSourcesRequests(paramsModificacionLogCredito, 'UP_INSERTAR_FORMA_COMUNICACION_LOG', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true, 'InsertFormaComunicacionLogModificacionC');
                Engine1Proxy.AddEventSourcingDataRequest(paramsModificacionLogCredito, "EVENTSOURCING_TRANSACTION_FORMA_COMUNICACION_LOG", 'Tarjetas', "ADMINEMPCUETAR", null, true, null,false, null);
                Engine1Proxy.AddEventSourcingDataRequest(paramsCambioTipo, "EVENTSOURCING_TRANSACTION_FORMA_COMUNICACION", 'Tarjetas', "ADMINEMPCUETAR", null, isQuery, null, deleteInstance, medioModificado.Id);
            }    

            if(!state.cliente.checkProductoCredito && !state.cliente.checkProductoPrepaga){
                //Engine1Proxy.AddDataSourcesRequests(paramsInsertModifLogSinCta, 'UP_INSERTAR_FORMA_COMUNICACION_LOG', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true, 'InsertFormaComunicacionLogModificacionC');
                Engine1Proxy.AddEventSourcingDataRequest(paramsInsertModifLogSinCta, "EVENTSOURCING_TRANSACTION_FORMA_COMUNICACION_LOG", 'Tarjetas', "ADMINEMPCUETAR", null, true, null,false, null);
                Engine1Proxy.AddEventSourcingDataRequest(paramsCambioTipo, "EVENTSOURCING_TRANSACTION_FORMA_COMUNICACION", 'Tarjetas', "ADMINEMPCUETAR", null, isQuery, null, deleteInstance, medioModificado.Id);
            }
            
            break;
        }
        case "EMAIL":{
            
            let desafectarMailPrepaga = false;
            let desafectarMailCredito = false;
            let medioEnModificacion = state.cliente.medioLocalizacionModificacion[0];
            const cuentaPrepagaId = cuentaPrepaga.CuentaTarjetaId ? cuentaPrepaga.CuentaTarjetaId : null;
            const cuentaCreditoId = cuentaCredito.CuentaTarjetaId ? cuentaCredito.CuentaTarjetaId : null;
            var asociaProducto = null;

            
            if(!medioEnModificacion.TipoProducto){//SI SE ESTÁ MODIFICANDO UN MEDIO QUE NO ESTABA ASOCIADO A CUENTAS Y AHORA SE TILDÓ ALGÚN TIPO DE CUENTA, HAY QUE BLANQUEAR EL MAIL QUE TENÍA ASOCIADO LA MISMA
                if(state.cliente.checkProductoPrepaga && (state.cliente.emailCuentasActuales && state.cliente.emailCuentasActuales.TP || (state.datosGuardado.datosPrepaga.emailViejoId)) ) desafectarMailPrepaga = true;
            }else if(medioEnModificacion.TipoProducto.includes("Prepaga")){//SE SE MODIFICA UN MEDIO QUE ESTABA ASOCIADO A UN TIPO DE CUENTA Y AHORA SE MARCA EL OTRO, HAY QUE DESAFECTAR
                if(!state.cliente.checkProductoPrepaga) desafectarMailPrepaga = true;
            }
     
            if(state.cliente.checkProductoPrepaga){
                asociaProducto = cuentaPrepagaId;
            } 
            if(state.cliente.checkProductoCredito){
                asociaProducto = cuentaCreditoId;
            } 

             //PARÁMETROS PARA EL EVENTSOURCING QUE MODIFICA EL REGISTRO EN FORMA_COMUNICACION
            let paramsCambioMedioElec ={
                'CONTACTO': state.cliente.emailEnEdicion,
                'CUENTA_TARJETA_ID': asociaProducto,
                'TIPO_COMUNICACION_ID': state.cliente.tipoDireccionElectronica,
                'CLIENTE_ID': state.cliente.id
            }

            //PARÁMETROS INSERT TABLA LOG DE LA FORMA DE COMUNICACIÓN MODIFICADA PARA LA CUENTA PREPAGA 
            let paramsModificacionLogPrepaga = {
                'FORMA_COMUNICACION_ID': state.cliente.checkProductoPrepaga ?  datosGuardado.datosPrepaga.emailViejoId : null,
                'TIPO_COMUNICACION_ID': state.cliente.tipoDireccionElectronica, 
                'CUENTA_TARJETA_ID': cuentaPrepaga.CuentaTarjetaId,
                'CLIENTE_ID': state.cliente.id,
                'CONTACTO': state.cliente.emailEnEdicion,
                'TIPO_OPERACION': "M",
                'USUARIO_OPERACION': usuario,
                "FECHA_OPERACION": new Date()
            }

            //PARÁMETROS INSERT TABLA LOG DE LA FORMA DE COMUNICACIÓN MODIFICADA PARA LA CUENTA CREDITO
            let paramsModificacionLogCredito = {
                'FORMA_COMUNICACION_ID':  state.cliente.checkProductoCredito ?  datosGuardado.datosCredito.emailViejoId : null,
                'TIPO_COMUNICACION_ID': state.cliente.tipoDireccionElectronica, 
                'CUENTA_TARJETA_ID': cuentaCredito.CuentaTarjetaId,
                'CLIENTE_ID': state.cliente.id,
                'CONTACTO': state.cliente.emailEnEdicion,
                'TIPO_OPERACION': "M",
                'USUARIO_OPERACION': usuario,
                "FECHA_OPERACION": new Date()
            }

            //PARÁMETROS INSERT TABLA LOG DE LA FORMA DE COMUNICACIÓN NO ASOCIADA A CUENTAS MODIFICADA
            let paramsModificacionLogSinCuenta = {
                'FORMA_COMUNICACION_ID':  medioEnModificacion.Id,
                'TIPO_COMUNICACION_ID': state.cliente.tipoDireccionElectronica, 
                'CUENTA_TARJETA_ID': asociaProducto,
                'CLIENTE_ID': state.cliente.id,
                'CONTACTO': state.cliente.emailEnEdicion,
                'TIPO_OPERACION': "M",
                'USUARIO_OPERACION': usuario,
                "FECHA_OPERACION": new Date()
            }

            //PARÁMETROS DESAFECTACIÓN DE LA CUENTA PREPAGA
            let paramsDesaf ={
                'CONTACTO': datosGuardado.datosPrepaga.emailViejo,
                'CUENTA_TARJETA_ID': null,
                'TIPO_COMUNICACION_ID': state.cliente.tipoDireccionElectronica
            }

            //PARÁMETROS DESAFECTACIÓN DE LA CUENTA PREPAGA
            let paramsDesafPorCheckModif ={
                'CONTACTO': state.cliente.emailEnEdicion,
                'CUENTA_TARJETA_ID': null,
                'TIPO_COMUNICACION_ID': state.cliente.tipoDireccionElectronica
            }

            //ES NECESARIO ENCONTRAR EL TIPO DE COMUNICACIÓN DE LA DIRECCIÓN ELECTRÓNICA ANTERIOR PORQUE A DIFERENCIA DE TELÉFONOS O POSTAL SE DESCONOCE LA CANTIDAD
            let tipoComElectronicaDesafectada;

            if(datosGuardado.datosPrepaga.emailViejoId){
                state.cliente.contactosTotal.map(m=>{
                    if(m.Id == datosGuardado.datosPrepaga.emailViejoId) tipoComElectronicaDesafectada = m.TipoComunicacionId;
                })
            };

            //PARÁMETROS DESAFECTACIÓN LOG
            let paramsDesafLogPrep = {
                'FORMA_COMUNICACION_ID':  datosGuardado.datosPrepaga.emailViejoId,
                'TIPO_COMUNICACION_ID': tipoComElectronicaDesafectada, 
                'CUENTA_TARJETA_ID': cuentaPrepaga.CuentaTarjetaId,
                'CLIENTE_ID': state.cliente.id,
                'CONTACTO': datosGuardado.datosPrepaga.emailViejo,
                'TIPO_OPERACION': "D",
                'USUARIO_OPERACION': usuario,
                "FECHA_OPERACION": new Date()
            }
                        
            //PARÁMETROS BAJA POR MODIFICACIÓN LOG
            let paramsBajaModifLogPrep = {
                'FORMA_COMUNICACION_ID':  datosGuardado.datosPrepaga.emailViejoId,
                'TIPO_COMUNICACION_ID': state.cliente.tipoDireccionElectronica, 
                'CUENTA_TARJETA_ID': cuentaPrepaga.CuentaTarjetaId,
                'CLIENTE_ID': state.cliente.id,
                'CONTACTO': datosGuardado.datosPrepaga.emailViejo,
                'TIPO_OPERACION': "X",
                'USUARIO_OPERACION': usuario,
                "FECHA_OPERACION": new Date()
            }

            if(!medioEnModificacion.TipoProducto){
                
                if(desafectarMailPrepaga){
                    //Engine1Proxy.AddDataSourcesRequests(paramsDesafLogPrep, 'UP_INSERTAR_FORMA_COMUNICACION_LOG', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true, 'InsertFormaComunicacionLogModificacion');
                    Engine1Proxy.AddEventSourcingDataRequest(paramsDesafLogPrep, "EVENTSOURCING_TRANSACTION_FORMA_COMUNICACION_LOG", 'Tarjetas', "ADMINEMPCUETAR", null, true, null,false, null);
                    Engine1Proxy.AddEventSourcingDataRequest(paramsDesaf, "EVENTSOURCING_TRANSACTION_FORMA_COMUNICACION", 'Tarjetas', "ADMINEMPCUETAR", null, isQuery, null, deleteInstance, datosGuardado.datosPrepaga.emailViejoId);
                }
                //Engine1Proxy.AddDataSourcesRequests(paramsModificacionLogSinCuenta, 'UP_INSERTAR_FORMA_COMUNICACION_LOG', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true, 'InsertFormaComunicacionLogModificac');
                Engine1Proxy.AddEventSourcingDataRequest(paramsModificacionLogSinCuenta, "EVENTSOURCING_TRANSACTION_FORMA_COMUNICACION_LOG", 'Tarjetas', "ADMINEMPCUETAR", null, true, null,false, null);
                Engine1Proxy.AddEventSourcingDataRequest(paramsCambioMedioElec, "EVENTSOURCING_TRANSACTION_FORMA_COMUNICACION", 'Tarjetas', "ADMINEMPCUETAR", null, isQuery, null, deleteInstance, medioEnModificacion.Id);
                
            }else{
                if(state.cliente.checkProductoPrepaga){
                    //Engine1Proxy.AddDataSourcesRequests(paramsModificacionLogSinCuenta, 'UP_INSERTAR_FORMA_COMUNICACION_LOG', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true, 'InsertFormaComunicacionLogModificacion');
                    Engine1Proxy.AddEventSourcingDataRequest(paramsModificacionLogSinCuenta, "EVENTSOURCING_TRANSACTION_FORMA_COMUNICACION_LOG", 'Tarjetas', "ADMINEMPCUETAR", null, true, null,false, null);
                    Engine1Proxy.AddEventSourcingDataRequest(paramsCambioMedioElec, "EVENTSOURCING_TRANSACTION_FORMA_COMUNICACION", 'Tarjetas', "ADMINEMPCUETAR", null, isQuery, null, deleteInstance, medioEnModificacion.Id);
                }
                
                if(state.cliente.checkProductoCredito){
                    //Engine1Proxy.AddDataSourcesRequests(paramsModificacionLogCredito, 'UP_INSERTAR_FORMA_COMUNICACION_LOG', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true, 'InsertFormaComunicacionLogModificacionC');
                    Engine1Proxy.AddEventSourcingDataRequest(paramsModificacionLogCredito, "EVENTSOURCING_TRANSACTION_FORMA_COMUNICACION_LOG", 'Tarjetas', "ADMINEMPCUETAR", null, true, null,false, null);
                    Engine1Proxy.AddEventSourcingDataRequest(paramsCambioMedioElec, "EVENTSOURCING_TRANSACTION_FORMA_COMUNICACION", 'Tarjetas', "ADMINEMPCUETAR", null, isQuery, null, deleteInstance, medioEnModificacion.Id);
                }
                
                if(!state.cliente.checkProductoCredito && !state.cliente.checkProductoPrepaga){
                    //Engine1Proxy.AddDataSourcesRequests(paramsBajaModifLogPrep, 'UP_INSERTAR_FORMA_COMUNICACION_LOG', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true, 'InsertFormaComunicacionLogModificacionC');
                    //Engine1Proxy.AddDataSourcesRequests(paramsModificacionLogSinCuenta, 'UP_INSERTAR_FORMA_COMUNICACION_LOG', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true, 'InsertFormaComunicacionLogModificacionC');
                    Engine1Proxy.AddEventSourcingDataRequest(paramsBajaModifLogPrep, "EVENTSOURCING_TRANSACTION_FORMA_COMUNICACION_LOG", 'Tarjetas', "ADMINEMPCUETAR", null, true, null,false, null);
                    Engine1Proxy.AddEventSourcingDataRequest(paramsModificacionLogSinCuenta, "EVENTSOURCING_TRANSACTION_FORMA_COMUNICACION_LOG", 'Tarjetas', "ADMINEMPCUETAR", null, true, null,false, null);
                    Engine1Proxy.AddEventSourcingDataRequest(paramsDesafPorCheckModif, "EVENTSOURCING_TRANSACTION_FORMA_COMUNICACION", 'Tarjetas', "ADMINEMPCUETAR", null, isQuery, null, deleteInstance, medioEnModificacion.Id);
                }
            }
            break;
        }
    }
        
    Engine1Proxy.Execute((data)=>_actualizarLocalizacionCliente(state.cliente.id, true), null, null, "ADMINEMPCUETAR");
}

function _modificarPostalEnBase(state,medio){
    _dispatch({ type: LOADING_CLIENTE });
    let domicilioModificacion = state.cliente.domicilioModificacion; // DOMICILIO CON DATOS ORIGINALES ANTES DE LA MODIFICACIÓN
    let domicilioModificado = state.datosGuardado.nuevoContacto; // DOMICILIO YA MODIFICADO
    let cuentaPrepaga = state.cliente.cuenta;
    let cuentaCredito = state.cliente.cuentaCredito;

    //DESAFECTACIONES Y AFECTACIONES A CUENTAS
    let desafectarCorrespondenciaPrepaga = domicilioModificacion.TipoProducto == "Tarjeta Prepaga" && domicilioModificacion.EsDomicilioCorrespondencia && !state.cliente.tarjeta_prepaga.some(t=>t.Descripcion == "Correspondencia" && t.Check);
    let desafectarCorrespondenciaCredito = domicilioModificacion.TipoProducto  && domicilioModificacion.TipoProducto.includes("de") &&  domicilioModificacion.EsDomicilioCorrespondencia && !state.cliente.tarjeta_credito.some(t=>t.Descripcion == "Correspondencia" && t.Check);
    let afectarLegalPrepaga = false;
    let afectarCorrespondenciaPrepaga = false;
    let afectarLegalCredito = false;
    let afectarCorrespondenciaCredito = false;
    
    //DESAFECTAR OTROS DOMICILIOS POR EXISTENCIA DE ASOCIACIONES PISADAS POR LA MODIFICACIÓN
    let desafectarLegalPrepagaPorModificacion = false;
    let desafectarCorrespondenciaPrepagaPorModificacion = false;
    let desafectarLegalCreditoPorModificacion = false;
    let desafectarCorrespondenciaCreditoPorModificacion = false;
    
    if(!domicilioModificacion.TipoProducto){//EL DOMICILIO NO ESTABA ASOCIADO A NINGUNA CUENTA
        if(state.cliente.tarjeta_prepaga.some(t=>t.Descripcion == "Correspondencia" && t.Check)){
            afectarCorrespondenciaPrepaga = true;
            desafectarCorrespondenciaPrepagaPorModificacion = cuentaPrepaga.DomicilioCorrespondenciaId &&   cuentaPrepaga.DomicilioCorrespondenciaId != domicilioModificacion.Id;
            // TRUE SI CORRESPONDE REGISTRAR LA DESAFECTACIÓN DEL DOMICILIO CORRESPONDENCIA DE LA CUENTA PREPAGA EN EL LOG PORQUE TENÍA OTRO
        } 

        if(state.cliente.tarjeta_prepaga.some(t=>t.Descripcion == "Legal" && t.Check)){
            afectarLegalPrepaga = true;
            desafectarLegalPrepagaPorModificacion = cuentaPrepaga.DomicilioParticularId &&   cuentaPrepaga.DomicilioParticularId != domicilioModificacion.Id;
            // TRUE SI CORRESPONDE REGISTRAR LA DESAFECTACIÓN DEL DOMICILIO LEGAL DE LA CUENTA PREPAGA EN EL LOG PORQUE TENÍA OTRO
        } 
        
        if(state.cliente.tarjeta_credito.some(t=>t.Descripcion == "Correspondencia" && t.Check)){
            afectarCorrespondenciaCredito = true;
            desafectarCorrespondenciaCreditoPorModificacion = cuentaCredito.DomicilioCorrespondenciaId &&   cuentaCredito.DomicilioCorrespondenciaId != domicilioModificacion.Id;
            // TRUE SI CORRESPONDE REGISTRAR LA DESAFECTACIÓN DEL DOMICILIO CORRESPONDENCIA DE LA CUENTA CRÉDITO EN EL LOG PORQUE TENÍA OTRO            
        } 

        if(state.cliente.tarjeta_credito.some(t=>t.Descripcion == "Legal" && t.Check)){
            afectarLegalCredito = true;
            desafectarLegalCreditoPorModificacion = cuentaCredito.DomicilioParticularId &&   cuentaCredito.DomicilioParticularId != domicilioModificacion.Id;
            // TRUE SI CORRESPONDE REGISTRAR LA DESAFECTACIÓN DEL DOMICILIO LEGAL DE LA CUENTA CRÉDITO EN EL LOG PORQUE TENÍA OTRO  
        } 

    }else if(domicilioModificacion.TipoProducto.includes("Prepaga")){//EL DOMICILIO ESTABA ASOCIADO A UNA CUENTA PREPAGA
        if(state.cliente.tarjeta_prepaga.some(t=>t.Descripcion == "Legal" && t.Check) && !domicilioModificacion.EsDomicilioLegal){
            afectarLegalPrepaga = true;
            desafectarLegalPrepagaPorModificacion = cuentaPrepaga.DomicilioParticularId && cuentaPrepaga.DomicilioParticularId != domicilioModificacion.Id;
        } 

        if(state.cliente.tarjeta_prepaga.some(t=>t.Descripcion == "Correspondencia" && t.Check) && !domicilioModificacion.EsDomicilioCorrespondencia){
            afectarCorrespondenciaPrepaga = true;
            desafectarCorrespondenciaPrepagaPorModificacion = cuentaPrepaga.DomicilioCorrespondenciaId && cuentaPrepaga.DomicilioCorrespondenciaId != domicilioModificacion.Id;
        } 

        if(state.cliente.tarjeta_credito.some(t=>t.Descripcion == "Correspondencia" && t.Check)){
            afectarCorrespondenciaCredito = true;
            desafectarCorrespondenciaCreditoPorModificacion = cuentaCredito.DomicilioCorrespondenciaId && cuentaCredito.DomicilioCorrespondenciaId != domicilioModificacion.Id;
        } 

        if(state.cliente.tarjeta_credito.some(t=>t.Descripcion == "Legal" && t.Check)){
            afectarLegalCredito = true;
            desafectarLegalCreditoPorModificacion = cuentaCredito.DomicilioParticularId && cuentaCredito.DomicilioParticularId != domicilioModificacion.Id;
        } 

    }else if(domicilioModificacion.TipoProducto.includes("de")){//EL DOMICILIO ESTABA ASOCIADO A UNA CUENTA CREDITO
        if(state.cliente.tarjeta_credito.some(t=>t.Descripcion == "Legal" && t.Check) && !domicilioModificacion.EsDomicilioLegal){
            afectarLegalCredito = true;
            desafectarLegalCreditoPorModificacion = cuentaCredito.DomicilioParticularId && cuentaCredito.DomicilioParticularId != domicilioModificacion.Id;
        } 

        if(state.cliente.tarjeta_credito.some(t=>t.Descripcion == "Correspondencia" && t.Check) && !domicilioModificacion.EsDomicilioCorrespondencia){
            afectarCorrespondenciaCredito = true;
            desafectarCorrespondenciaCreditoPorModificacion = cuentaCredito.DomicilioCorrespondenciaId && cuentaCredito.DomicilioCorrespondenciaId != domicilioModificacion.Id;
        } 

        if(state.cliente.tarjeta_prepaga.some(t=>t.Descripcion == "Correspondencia" && t.Check)){
            afectarCorrespondenciaPrepaga = true;
            desafectarCorrespondenciaPrepagaPorModificacion = cuentaPrepaga.DomicilioCorrespondenciaId && cuentaPrepaga.DomicilioCorrespondenciaId != domicilioModificacion.Id;
        } 

        if(state.cliente.tarjeta_prepaga.some(t=>t.Descripcion == "Legal" && t.Check)){
            afectarLegalPrepaga = true;
            desafectarLegalPrepagaPorModificacion = cuentaPrepaga.DomicilioParticularId && cuentaPrepaga.DomicilioParticularId != domicilioModificacion.Id;
        } 
    }

    let paramsAfectacionLegalPrepaga, paramsDesafectacionLegalPrepaga, paramsAfectacionLegalCredito, paramsDesafectacionLegalCredito, paramsAfectacionCorrespondenciaPrepaga, paramsDesafectacionCorrespondenciaPrepaga, paramsAfectacionCorrespondenciaCredito, paramsDesafectacionCorrespondenciaCredito;
    
    if(afectarLegalPrepaga){//SE ASOCIA EL DOMICILIO MODIFICADO A LA CUENTA PREPAGA (LEGAL) Y, SI CORRESPONDE, SE REGISTRA LA DESAFECTACIÓN DEL QUE TENÍA ASOCIADO
        paramsAfectacionLegalPrepaga={
            "DOMICILIO_PARTICULAR_ID": domicilioModificacion.Id
        }

        if(desafectarLegalPrepagaPorModificacion){

            let domicilioDesafectado = state.cliente.domiciliosTotal.reduce((acum,currentValue)=>{
                if(currentValue.Id == cuentaPrepaga.DomicilioParticularId){
                     return currentValue
                    }else{
                    return acum
                }},{Id:0});

            paramsDesafectacionLegalPrepaga={
                "DOMICILIO_ID":domicilioDesafectado.Id,
                "CLIENTE_ID":state.cliente.id,
                "TIPO_DOMICILIO":null,
                "CALLE":domicilioDesafectado.Calle,
                "NUMERO":domicilioDesafectado.Numero,
                "DEPARTAMENTO":domicilioDesafectado.Departamento,
                "PISO":domicilioDesafectado.Piso,
                "LOCALIDAD":domicilioDesafectado.Localidad,
                "PROVINCIA_ID":parseInt(domicilioDesafectado.ProvinciaId),
                "CODIGO_POSTAL":domicilioDesafectado.CodigoPostalId,
                "PAIS_ID":parseInt(domicilioDesafectado.PaisId),
                "COMENTARIO":domicilioDesafectado.Comentario,
                "TIPO_OPERACION":"D",
                "FECHA_HORA_OPERACION":new Date(),
                "USUARIO_OPERACION": state.sesion.executionContext.login,
                "PREPAGA_LEGAL_ID":cuentaPrepaga.CuentaTarjetaId
            }

            Engine1Proxy.AddEventSourcingDataRequest(paramsDesafectacionLegalPrepaga, "EVENTSOURCING_TRANSACTION_DOMICILIO_LOG", 'Tarjetas', "ADMINEMPCUETAR", null, true, null, false,null);
        }

        Engine1Proxy.AddEventSourcingDataRequest(paramsAfectacionLegalPrepaga, "EVENTSOURCING_TRANSACTION_CUENTA_TARJETA", 'Tarjetas', "ADMINEMPCUETAR", null, true, null, false,cuentaPrepaga.CuentaTarjetaId);
    }

    if(afectarCorrespondenciaPrepaga){//SE ASOCIA EL DOMICILIO MODIFICADO A LA CUENTA PREPAGA (CORRESPONDENCIA) Y, SI CORRESPONDE, SE REGISTRA LA DESAFECTACIÓN DEL QUE TENÍA ASOCIADO
        paramsAfectacionCorrespondenciaPrepaga = {
            "DOMICILIO_CORRESPONDENCIA_ID": domicilioModificacion.Id
        }

        if(desafectarCorrespondenciaPrepagaPorModificacion){

            let domicilioDesafectado = state.cliente.domiciliosTotal.reduce((acum,currentValue)=>{
                if(currentValue.Id == cuentaPrepaga.DomicilioCorrespondenciaId){
                     return currentValue
                    }else{
                    return acum
                }},{Id:0});

            paramsDesafectacionCorrespondenciaPrepaga={
                "DOMICILIO_ID":domicilioDesafectado.Id,
                "CLIENTE_ID":state.cliente.id,
                "TIPO_DOMICILIO":null,
                "CALLE":domicilioDesafectado.Calle,
                "NUMERO":domicilioDesafectado.Numero,
                "DEPARTAMENTO":domicilioDesafectado.Departamento,
                "PISO":domicilioDesafectado.Piso,
                "LOCALIDAD":domicilioDesafectado.Localidad,
                "PROVINCIA_ID":parseInt(domicilioDesafectado.ProvinciaId),
                "CODIGO_POSTAL":domicilioDesafectado.CodigoPostalId,
                "PAIS_ID":parseInt(domicilioDesafectado.PaisId),
                "COMENTARIO":domicilioDesafectado.Comentario,
                "TIPO_OPERACION":"D",
                "FECHA_HORA_OPERACION":new Date(),
                "USUARIO_OPERACION": state.sesion.executionContext.login,
                "PREPAGA_CORRESP_ID":cuentaPrepaga.CuentaTarjetaId
            }

            Engine1Proxy.AddEventSourcingDataRequest(paramsDesafectacionCorrespondenciaPrepaga, "EVENTSOURCING_TRANSACTION_DOMICILIO_LOG", 'Tarjetas', "ADMINEMPCUETAR", null, true, null, false,null);
        }

        Engine1Proxy.AddEventSourcingDataRequest(paramsAfectacionCorrespondenciaPrepaga, "EVENTSOURCING_TRANSACTION_CUENTA_TARJETA", 'Tarjetas', "ADMINEMPCUETAR", null, true, null, false,cuentaPrepaga.CuentaTarjetaId);
    }

    if(afectarLegalCredito){ //SE ASOCIA EL DOMICILIO MODIFICADO A LA CUENTA CRÉDITO (LEGAL) Y, SI CORRESPONDE, SE REGISTRA LA DESAFECTACIÓN DEL QUE TENÍA ASOCIADO
        paramsAfectacionLegalCredito = {
            "DOMICILIO_PARTICULAR_ID": domicilioModificacion.Id
        }

        if(desafectarLegalCreditoPorModificacion){

            let domicilioDesafectado = state.cliente.domiciliosTotal.reduce((acum,currentValue)=>{
                if(currentValue.Id == cuentaCredito.DomicilioParticularId){
                     return currentValue
                    }else{
                    return acum
                }},{Id:0});

                paramsDesafectacionLegalCredito={
                "DOMICILIO_ID":domicilioDesafectado.Id,
                "CLIENTE_ID":state.cliente.id,
                "TIPO_DOMICILIO":null,
                "CALLE":domicilioDesafectado.Calle,
                "NUMERO":domicilioDesafectado.Numero,
                "DEPARTAMENTO":domicilioDesafectado.Departamento,
                "PISO":domicilioDesafectado.Piso,
                "LOCALIDAD":domicilioDesafectado.Localidad,
                "PROVINCIA_ID":parseInt(domicilioDesafectado.ProvinciaId),
                "CODIGO_POSTAL":domicilioDesafectado.CodigoPostalId,
                "PAIS_ID":parseInt(domicilioDesafectado.PaisId),
                "COMENTARIO":domicilioDesafectado.Comentario,
                "TIPO_OPERACION":"D",
                "FECHA_HORA_OPERACION":new Date(),
                "USUARIO_OPERACION": state.sesion.executionContext.login
            }

            Engine1Proxy.AddEventSourcingDataRequest(paramsDesafectacionLegalCredito, "EVENTSOURCING_TRANSACTION_DOMICILIO_LOG", 'Tarjetas', "ADMINEMPCUETAR", null, true, null, false,null);
        }

        Engine1Proxy.AddEventSourcingDataRequest(paramsAfectacionLegalCredito, "EVENTSOURCING_TRANSACTION_CUENTA_TARJETA", 'Tarjetas', "ADMINEMPCUETAR", null, true, null, false,cuentaCredito.CuentaTarjetaId);
    }

    if(afectarCorrespondenciaCredito){//SE ASOCIA EL DOMICILIO MODIFICADO A LA CUENTA CRÉDITO (CORRESPONDENCIA) Y, SI CORRESPONDE, SE REGISTRA LA DESAFECTACIÓN DEL QUE TENÍA ASOCIADO
        paramsAfectacionCorrespondenciaCredito = {
            "DOMICILIO_PARTICULAR_ID": domicilioModificacion.Id
        }

        if(desafectarCorrespondenciaCreditoPorModificacion){

            let domicilioDesafectado = state.cliente.domiciliosTotal.reduce((acum,currentValue)=>{
                if(currentValue.Id == cuentaCredito.DomicilioCorrespondenciaId){
                     return currentValue
                    }else{
                    return acum
                }},{Id:0});

                paramsDesafectacionCorrespondenciaCredito={
                "DOMICILIO_ID":domicilioDesafectado.Id,
                "CLIENTE_ID":state.cliente.id,
                "TIPO_DOMICILIO":null,
                "CALLE":domicilioDesafectado.Calle,
                "NUMERO":domicilioDesafectado.Numero,
                "DEPARTAMENTO":domicilioDesafectado.Departamento,
                "PISO":domicilioDesafectado.Piso,
                "LOCALIDAD":domicilioDesafectado.Localidad,
                "PROVINCIA_ID":parseInt(domicilioDesafectado.ProvinciaId),
                "CODIGO_POSTAL":domicilioDesafectado.CodigoPostalId,
                "PAIS_ID":parseInt(domicilioDesafectado.PaisId),
                "COMENTARIO":domicilioDesafectado.Comentario,
                "TIPO_OPERACION":"D",
                "FECHA_HORA_OPERACION":new Date(),
                "USUARIO_OPERACION": state.sesion.executionContext.login
            }

            Engine1Proxy.AddEventSourcingDataRequest(paramsDesafectacionCorrespondenciaCredito, "EVENTSOURCING_TRANSACTION_DOMICILIO_LOG", 'Tarjetas', "ADMINEMPCUETAR", null, true, null, false,null);
        }

        Engine1Proxy.AddEventSourcingDataRequest(paramsAfectacionCorrespondenciaCredito, "EVENTSOURCING_TRANSACTION_CUENTA_TARJETA", 'Tarjetas', "ADMINEMPCUETAR", null, true, null, false,cuentaCredito.CuentaTarjetaId);
    }

    let paramsDesafectacionPrepagaCheck, paramsDesafectacionPrepagaCheckLog, paramsDesafectacionCreditoCheck, paramsDesafectacionCreditoCheckLog;

    //SI EL DOMICILIO QUE SE MODIFICÓ ESTABA ASOCIADO A UNA CUENTA PREPAGA Y SE LE DESTILDÓ EL CHECK CORRESPONDE LA DESAFECTACIÓN (SOLO PARA CASO CORRESPONDENCIA, PARA LEGAL NO SE PUEDE DAR)
    if(desafectarCorrespondenciaPrepaga){
        paramsDesafectacionPrepagaCheck = {
            "DOMICILIO_CORRESPONDENCIA_ID": null
        }

        paramsDesafectacionPrepagaCheckLog = {
            "DOMICILIO_ID":domicilioModificado.Id,
            "CLIENTE_ID":state.cliente.id,
            "TIPO_DOMICILIO":null,
            "CALLE":domicilioModificado.calle,
            "NUMERO":domicilioModificado.altura,
            "DEPARTAMENTO":domicilioModificado.depto,
            "PISO":domicilioModificado.piso,
            "LOCALIDAD":domicilioModificado.localidad,
            "PROVINCIA_ID":domicilioModificado.provincia,
            "CODIGO_POSTAL":domicilioModificado.codigoPostal,
            "PAIS_ID":domicilioModificado.pais,
            "COMENTARIO":domicilioModificado.comentarios,
            "PREPAGA_LEGAL_ID": cuentaPrepaga.CuentaTarjetaId,
            "TIPO_OPERACION":"X",
            "FECHA_HORA_OPERACION":new Date(),
            "USUARIO_OPERACION": state.sesion.executionContext.login
        }

        Engine1Proxy.AddEventSourcingDataRequest(paramsDesafectacionPrepagaCheckLog, "EVENTSOURCING_TRANSACTION_DOMICILIO_LOG", 'Tarjetas', "ADMINEMPCUETAR", null, true, null, false,null);
        Engine1Proxy.AddEventSourcingDataRequest(paramsDesafectacionPrepagaCheck, "EVENTSOURCING_TRANSACTION_CUENTA_TARJETA", 'Tarjetas', "ADMINEMPCUETAR", null, true, null, false,cuentaPrepaga.CuentaTarjetaId);
    }

    //SI EL DOMICILIO QUE SE MODIFICÓ ESTABA ASOCIADO A UNA CUENTA CRÉDITO Y SE LE DESTILDÓ EL CHECK CORRESPONDE LA DESAFECTACIÓN (SOLO PARA CASO CORRESPONDENCIA, PARA LEGAL NO SE PUEDE DAR)
    if(desafectarCorrespondenciaCredito){
        paramsDesafectacionCreditoCheck = {
            "DOMICILIO_CORRESPONDENCIA_ID": null
        }

        paramsDesafectacionCreditoCheckLog = {
            "DOMICILIO_ID":domicilioModificado.Id,
            "CLIENTE_ID":state.cliente.id,
            "TIPO_DOMICILIO":null,
            "CALLE":domicilioModificado.calle,
            "NUMERO":domicilioModificado.altura,
            "DEPARTAMENTO":domicilioModificado.depto,
            "PISO":domicilioModificado.piso,
            "LOCALIDAD":domicilioModificado.localidad,
            "PROVINCIA_ID":domicilioModificado.provincia,
            "CODIGO_POSTAL":domicilioModificado.codigoPostal,
            "PAIS_ID":domicilioModificado.pais,
            "COMENTARIO":domicilioModificado.comentarios,
            "TIPO_OPERACION":"X",
            "FECHA_HORA_OPERACION":new Date(),
            "USUARIO_OPERACION": state.sesion.executionContext.login
        }

        Engine1Proxy.AddEventSourcingDataRequest(paramsDesafectacionCreditoCheckLog, "EVENTSOURCING_TRANSACTION_DOMICILIO_LOG", 'Tarjetas', "ADMINEMPCUETAR", null, true, null, false,null);
        Engine1Proxy.AddEventSourcingDataRequest(paramsDesafectacionCreditoCheck, "EVENTSOURCING_TRANSACTION_CUENTA_TARJETA", 'Tarjetas', "ADMINEMPCUETAR", null, true, null, false,cuentaCredito.CuentaTarjetaId);
    }
    


    let paramsModificacionDomicilioLog = {
        "DOMICILIO_ID":state.cliente.domicilioModificacion.Id,
        "CLIENTE_ID":state.cliente.id,
        "CALLE":domicilioModificado.calle,
        "NUMERO":domicilioModificado.altura,
        "DEPARTAMENTO":domicilioModificado.depto ? domicilioModificado.depto : null,
        "PISO":domicilioModificado.piso ? domicilioModificado.piso : null,
        "LOCALIDAD":domicilioModificado.localidad,
        "PROVINCIA_ID":state.cliente.provinciaId,
        "CODIGO_POSTAL":domicilioModificado.codigoPostal,
        "PAIS_ID":state.cliente.paisId,
        "COMENTARIO":domicilioModificado.comentarios ? domicilioModificado.comentarios : null,
        "TIPO_OPERACION":"M",
        "FECHA_HORA_OPERACION":new Date(),
        "USUARIO_OPERACION": state.sesion.executionContext.login,
        "PREPAGA_LEGAL_ID": afectarLegalPrepaga ? cuentaPrepaga.CuentaTarjetaId : null,
        "PREPAGA_CORRESP_ID": afectarCorrespondenciaPrepaga ? cuentaPrepaga.CuentaTarjetaId : null
    }

    if(cuentaPrepaga.DomicilioParticularId == state.cliente.domicilioModificacion.Id) paramsModificacionDomicilioLog.PREPAGA_LEGAL_ID = cuentaPrepaga.CuentaTarjetaId;
    if(cuentaPrepaga.DomicilioCorrespondenciaId == state.cliente.domicilioModificacion.Id) paramsModificacionDomicilioLog.PREPAGA_CORRESP_ID = cuentaPrepaga.CuentaTarjetaId;

    let paramsEventSourcingDomicilio={
        "CLIENTE_ID":state.cliente.id,
        "CALLE":domicilioModificado.calle,
        "NUMERO":domicilioModificado.altura,
        "PISO":domicilioModificado.piso ? domicilioModificado.piso : null,
        "DEPARTAMENTO":domicilioModificado.depto ? domicilioModificado.depto : null,
        "LOCALIDAD":domicilioModificado.localidad,
        "PROVINCIA_ID": state.cliente.provinciaId,
        "CODIGO_POSTAL":domicilioModificado.codigoPostal,
        "FECHA_ULTIMA_MODIFICACION":new Date(),
        "PAIS_ID":state.cliente.paisId,
        "ACTIVO":1,
        "COMENTARIO": domicilioModificado.comentarios ? domicilioModificado.comentarios : null
    }

    Engine1Proxy.AddEventSourcingDataRequest(paramsModificacionDomicilioLog, "EVENTSOURCING_TRANSACTION_DOMICILIO_LOG", 'Tarjetas', "ADMINEMPCUETAR", null, true, null, false,null);
    Engine1Proxy.AddEventSourcingDataRequest(paramsEventSourcingDomicilio, "EVENTSOURCING_TRANSACTION_DOMICILIO", 'Tarjetas', "ADMINEMPCUETAR", null, true, null, false,state.cliente.domicilioModificacion.Id);    
    
    Engine1Proxy.Execute((data) => _actualizarDomiciliosCliente(state.cliente.id), null, null, "CONSULTASOCIOS");
}


